<template>
  <!-- eslint-disable no-mixed-spaces-and-tabs -->
  <div class="map">
    <!-- <span class="asd">
      <div ref="animatedNumber" style="position:relative">
      </div>
    </span> -->
    <div class="map_inner" id="map">
      <div v-if="!getIsMobile" class="info_btn" @click="infoModal = !infoModal">
        <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48px" height="48px">
          <path
            d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 7 L 11 9 L 13 9 L 13 7 L 11 7 z M 11 11 L 11 17 L 13 17 L 13 11 L 11 11 z" />
        </svg>
      </div>
      <div v-if="!getIsMobile" class="dc_btn" @click="DCmodeToggle">
        <span style="color: #ef7f1a; font-weight: 500;" v-if="this.getDCmode">DC</span>
        <div style="font-weight: 500; line-height: 1; font-size: 14px" v-else><span style="color:#61a321">AC</span>/<span style="color: #ef7f1a">DC</span></div>
      </div>
      <div style="display: none!important" v-if="!this.$store.getters.getIsMobile" class="flot_desktop_btn"
        @click="open_in_new_tab()">
        <img src="/images/flot_desktop.png" alt="" />
      </div>
      <div style="display: none" class="pwa_btn" @click="installPWA">
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 490 490"
          style="enable-background: new 0 0 490 490" xml:space="preserve">
          <path d="M245,0c-9.5,0-17.2,7.7-17.2,17.2v331.2L169,289.6c-6.7-6.7-17.6-6.7-24.3,0s-6.7,17.6,0,24.3l88.1,88.1
                    c3.3,3.3,7.7,5,12.1,5c4.4,0,8.8-1.7,12.1-5l88.1-88.1c6.7-6.7,6.7-17.6,0-24.3c-6.7-6.7-17.6-6.7-24.3,0L262,348.4V17.1
                    C262.1,7.6,254.5,0,245,0z" />
          <path d="M462.1,472.9v-99.7c0-9.5-7.7-17.2-17.2-17.2s-17.2,7.7-17.2,17.2v82.6H62.2v-82.6c0-9.5-7.7-17.2-17.1-17.2
                    s-17.2,7.7-17.2,17.2v99.7c0,9.5,7.7,17.1,17.2,17.1h399.8C454.4,490,462.1,482.4,462.1,472.9z" />
        </svg>
      </div>
      <transition name="fade">
        <div v-if="infoModal" id="info_modal" class="info_modal">
          <div class="info_modal_inner">
            <a @click.prevent="infoModal = false">
              <svg height="15px" viewBox="0 0 311 311.07733" width="15px" xmlns="http://www.w3.org/2000/svg">
                <path fill="#fff"
                  d="m16.035156 311.078125c-4.097656 0-8.195312-1.558594-11.308594-4.695313-6.25-6.25-6.25-16.382812 0-22.632812l279.0625-279.0625c6.25-6.25 16.382813-6.25 22.632813 0s6.25 16.382812 0 22.636719l-279.058594 279.058593c-3.136719 3.117188-7.234375 4.695313-11.328125 4.695313zm0 0" />
                <path fill="#fff"
                  d="m295.117188 311.078125c-4.097657 0-8.191407-1.558594-11.308594-4.695313l-279.082032-279.058593c-6.25-6.253907-6.25-16.386719 0-22.636719s16.382813-6.25 22.636719 0l279.058594 279.0625c6.25 6.25 6.25 16.382812 0 22.632812-3.136719 3.117188-7.230469 4.695313-11.304687 4.695313zm0 0" />
              </svg>
            </a>
            <div class="info">
              <div class="item">
                <div class="icon">
                  <img style="margin-right: 10px;" src="/images/location_icons/flash-ac-blue.png" />
                  <img src="/images/location_icons/flash-dc-blue.png" />
                </div>
                <div class="text">{{ $t("fully_occupied") }}</div>
              </div>
              <div class="item">
                <div class="icon">
                  <img style="margin-right: 10px;" src="/images/location_icons/flash-ac-green.png" />
                  <img src="/images/location_icons/flash-dc-orange.png" />
                </div>
                <div class="text">{{ $t("station_free") }}</div>
              </div>
              <div class="item">
                <div class="icon">
                  <img style="margin-right: 10px;" src="/images/location_icons/flash-ac-gray.png" />
                  <img src="/images/location_icons/flash-dc-gray.png" />
                </div>
                <div class="text">{{ $t("coming_soon") }}</div>
              </div>
              <div class="item">
                <div class="icon">
                  <img style="margin-right: 10px;" src="/images/location_icons/flash-ac-red.png" />
                  <img src="/images/location_icons/flash-dc-red.png" />
                </div>
                <div class="text">{{ $t("not_available") }}</div>
              </div>
              <div class="item">
                <div class="icon">
                  <img style="margin-right: 10px;" src="/images/location_icons/flash-ac-blue-green.png" />
                  <img src="/images/location_icons/flash-dc-blue-orange.png" />
                </div>
                <div class="text">{{ $t("partially_occupied") }}</div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div v-if="!getIsMobile" @click="nearStation()" class="near_station">
        <svg height="20px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
          <path
            d="m8.828125 282.484375h45.902344c12.0625 91.066406 83.71875 162.722656 174.785156 174.785156v45.902344c.015625 4.871094 3.960937 8.8125 8.828125 8.828125h35.3125c4.867188-.015625 8.8125-3.957031 8.828125-8.828125v-45.902344c91.066406-12.0625 162.722656-83.71875 174.785156-174.785156h45.902344c4.871094-.015625 8.8125-3.960937 8.828125-8.828125v-35.3125c-.015625-4.867188-3.957031-8.8125-8.828125-8.828125h-45.902344c-12.0625-91.066406-83.71875-162.722656-174.785156-174.785156v-45.902344c-.015625-4.871094-3.960937-8.8125-8.828125-8.828125h-35.3125c-4.867188.015625-8.8125 3.957031-8.828125 8.828125v45.902344c-91.066406 12.0625-162.722656 83.71875-174.785156 174.785156h-45.902344c-4.871094.015625-8.8125 3.960937-8.828125 8.828125v35.3125c.015625 4.867188 3.957031 8.8125 8.828125 8.828125zm247.171875-176.554687c82.878906 0 150.070312 67.191406 150.070312 150.070312s-67.191406 150.070312-150.070312 150.070312-150.070312-67.191406-150.070312-150.070312c.117187-82.832031 67.238281-149.953125 150.070312-150.070312zm0 0" />
          <path
            d="m326.621094 256c0 39.003906-31.617188 70.621094-70.621094 70.621094s-70.621094-31.617188-70.621094-70.621094 31.617188-70.621094 70.621094-70.621094 70.621094 31.617188 70.621094 70.621094zm0 0" />
        </svg>
      </div>
      <div style="display: none" class="coverage_area">
        <div @click="coverageArea = !coverageArea" class="icon" :class="{ active: coverageArea }">
          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px" y="0px" height="20px" viewBox="0 0 148.602 148.602" style="" xml:space="preserve">
            <path d="M74.301,0C33.333,0,0,33.333,0,74.301c0,40.969,33.333,74.301,74.301,74.301c40.969,0,74.301-33.332,74.301-74.301
                  C148.602,33.333,115.27,0,74.301,0z M132.768,77.954h3.537c-1.897,32.56-28.978,58.468-62.004,58.468
                  c-34.254,0-62.121-27.867-62.121-62.121c0-34.253,27.867-62.12,62.121-62.12c33.846,0,61.436,27.211,62.09,60.902h-3.623
                  c-1.348,0-2.437,1.089-2.437,2.437S131.42,77.954,132.768,77.954z" />
            <path d="M110.842,73.083h-7.308c-1.349,0-2.437,1.089-2.437,2.437s1.088,2.436,2.437,2.436h7.308c1.348,0,2.438-1.088,2.438-2.436
                  C113.277,74.172,112.189,73.083,110.842,73.083z" />
            <path d="M96.227,73.083h-7.309c-1.348,0-2.438,1.089-2.438,2.437s1.09,2.436,2.438,2.436h7.309c1.347,0,2.437-1.088,2.437-2.436
                  C98.662,74.172,97.572,73.083,96.227,73.083z" />
            <path d="M125.459,73.083h-7.309c-1.349,0-2.437,1.089-2.437,2.437s1.088,2.436,2.437,2.436h7.309c1.348,0,2.436-1.088,2.436-2.436
                  S126.807,73.083,125.459,73.083z" />
            <path d="M81.609,73.083H74.3c-1.347,0-2.436,1.089-2.436,2.437s1.089,2.436,2.436,2.436h7.31c1.347,0,2.436-1.088,2.436-2.436
                  S82.956,73.083,81.609,73.083z" />
          </svg>
        </div>
        <div class="circle_radius">
          <svg :class="{ rotated: coverageAreaRadiusShowed }"
            @click="coverageAreaRadiusShowed = !coverageAreaRadiusShowed" version="1.1" id="Capa_1"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="18px"
            viewBox="0 0 255 255" style="enable-background: new 0 0 255 255" xml:space="preserve">
            <g id="arrow-drop-down">
              <polygon points="0,63.75 127.5,191.25 255,63.75" />
            </g>
          </svg>
          <transition name="slide">
            <div class="toggled_block" v-if="coverageAreaRadiusShowed">
              <div class="rounded_radius">
                <input type="text" readonly v-model="roundedCircleRadius" />
              </div>
              <input class="range_radius" v-model="coverageAreaCircleRadius" type="range" min="25000" max="100000"
                step="5000" />
            </div>
          </transition>
        </div>
      </div>
      <l-map @click="
        (locationModal = false),
        (chargeView = false),
        (confirmationCharge = null)
      " :zoom="zoom" :center="center" @ready="initMapReady()" :options="mapOptions" style="height: 100%" ref="osm_map">
        <l-tile-layer :options="tile_options" :url="url" :attribution="attribution" />
        <l-circle :visible="coverageArea" v-for="item in getStations" :key="item.center"
          :lat-lng="[item.Corlat, item.Corlng]" :radius="coverageAreaCircleRadiusToNumber" :stroke="false"
          :options="{ color: 'green', fillOpacity: 1, fillColor: 'blue' }" />
        <l-marker v-if="realtime" :lat-lng="[realtime.lat, realtime.lng]">
          <l-icon :icon-size="[this.iconSize, this.iconSize]" :icon-anchor="[this.iconSize, this.iconSize]"
            icon-url="/images/green-circle.png" />
        </l-marker>
        <v-marker-cluster :options="clusterOptions" ref="clusterRef">
          <l-marker @click="triggerStationModal(item)" :item="item.Key" :opacity="0.1" :ref="`${item.Key}`"
            v-for="item in getStations" :key="item.Key" :lat-lng="[item.Corlat, item.Corlng]">
            <l-icon :icon-url="switchIcon(item.BespsLocationType, item.BespbLocationStatus)" :shadowUrl="iconShadow" :iconRetinaUrl="switchIcon(item.BespsLocationType, item.BespbLocationStatus)" :shadowAnchor="[11, 40]" :iconAnchor="[11, 30]" :iconSize="[22, 33]" />
          </l-marker>
        </v-marker-cluster>
      </l-map>
      <ListPage v-if="getListPage" />
      <FavoritesPage v-if="getFavoritesPage" />
      <transition name="fade">
        <div v-if="locationModal" id="location_modal" class="location_modal">
          <img v-if="activeSpinner" src="/images/new_spinner.gif" alt="" />
          <div @click="locationModal = false" v-if="locationModal" class="modal_header">
            <span class="modal_close_icon">&#10005;</span>
          </div>

          <!-- ------1------ -->
          <div v-if="
            modalStatus === 1 &&
            default_charge &&
            !activeSpinner &&
            !activeStationPopup
          " class="default_charge">
            <div class="location_info">
              <div class="row1">
                <div class="left">
                  <span class="location_title">
                    <strong>
                      {{ getSessionModalData.Title.replace("amp;", "") }}
                    </strong>
                    <br />
                    <small>{{ getSessionModalData.NetworkCity }}</small>
                  </span>
                </div>
                <div class="right">
                  <div @click="
                    toggleFavorite(
                      getSessionModalData.Bookmark,
                      getSessionModalData.Key
                    )
                  " :class="{ favorite: getSessionModalData.Bookmark > 0 }" class="heart">
                    <svg version="1.1" height="20" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 485 485"
                      style="enable-background: new 0 0 485 485" xml:space="preserve">
                      <path fill="#808080" d="M343.611,22.543c-22.613,0-44.227,5.184-64.238,15.409c-13.622,6.959-26.136,16.205-36.873,27.175
                            c-10.738-10.97-23.251-20.216-36.873-27.175c-20.012-10.225-41.625-15.409-64.239-15.409C63.427,22.543,0,85.97,0,163.932
                            c0,55.219,29.163,113.866,86.678,174.314c48.022,50.471,106.816,92.543,147.681,118.95l8.141,5.261l8.141-5.261
                            c40.865-26.406,99.659-68.479,147.682-118.95C455.838,277.798,485,219.151,485,163.932C485,85.97,421.573,22.543,343.611,22.543z
                             M376.589,317.566c-42.918,45.106-95.196,83.452-134.089,109.116c-38.893-25.665-91.171-64.01-134.088-109.116
                            C56.381,262.884,30,211.194,30,163.932c0-61.42,49.969-111.389,111.389-111.389c35.361,0,67.844,16.243,89.118,44.563
                            l11.993,15.965l11.993-15.965c21.274-28.32,53.757-44.563,89.118-44.563c61.42,0,111.389,49.969,111.389,111.389
                            C455,211.194,428.618,262.884,376.589,317.566z" />
                    </svg>
                  </div>
                  <div v-if="
                    this.$store.getters.getIsMobile && webShareApiSupported
                  " class="share" @click="share_station(getSessionModalData)">
                    <svg fill="none" height="24" stroke="#808080" stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="18" cy="5" r="3" />
                      <circle cx="6" cy="12" r="3" />
                      <circle cx="18" cy="19" r="3" />
                      <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
                      <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
                    </svg>
                  </div>
                </div>
              </div>
              <div class="row2">
                <div v-if="getSessionModalData.Price" class="tariff">
                  <strong>{{ getSessionModalData.Price }} BGN {{ $t("za") }} 1
                    kWh</strong>
                </div>
                <hr v-if="getSessionModalData.Price" />
                <div class="worktime">
                  <strong><span>{{ getSessionModalData.Hours }}</span></strong>
                </div>
              </div>
            </div>
            <div class="stations" v-if="parseStations(getSessionModalData.StationsObj).length > 0">
              <div class="station" v-for="station in parseStations(
                getSessionModalData.StationsObj
              )" :key="station.id">
                <div @click="setConfirmationCharge(station, getSessionModalData.BespbLocationStatus)" class="station_info_inner_left">
                  <span style="font-weight: bold;" :class="colorStatus(station.StatusId, getSessionModalData.BespbLocationStatus)" class="id">{{ station.id }}</span>
                  <div class="properties">
                    <div v-for="(value, key) in station.Charge" :key="key">
                        <span>{{ key }} - {{ value }} kW</span>
                    </div>
                    <span :class="colorStatus(station.StatusId)" v-if="station.StatusId === 2">
                      {{ $t("fully_occupied") }}
                    </span>
                    <span :class="colorStatus(station.StatusId)" v-if="station.StatusId === 3">
                      <!-- {{ $t("station_free") }} -->
                    </span>
                    <span :class="colorStatus(station.StatusId)" v-if="station.StatusId === 4">
                      {{ $t("partially_occupied") }}
                    </span>
                  </div>
                </div>
                <div @click="setConfirmationCharge(station, getSessionModalData.BespbLocationStatus)" class="station_info_inner_rfid_status">
                  <svg v-if="station.Nfc == 1 && station.StatusId != 1" fill="#61a321" width="25" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 122.88 122.02">
                    <title>RFID</title>
                    <path
                      d="M62.19,48.52a9.83,9.83,0,0,0-.25-19.61h-1a9.83,9.83,0,0,0,0,19.63h1.25ZM24.53,91q6,0,9.29,2.7a8.86,8.86,0,0,1,3.24,7.16q0,5.11-3.17,7.7c-2.11,1.72-5.19,2.58-9.22,2.58l-1.08.56H18.42V122H7.72V91Zm-1.88,13.52a4.41,4.41,0,0,0,2.6-.63,3.27,3.27,0,0,0,0-4.44,4.26,4.26,0,0,0-2.6-.66H18.42v5.73Zm6.47,2.3L38.79,122H26.92l-7.23-13.56,9.43-1.6Zm37.37-7.79H51.75v4.32H63.67v8H51.75V122H40.81V91H66.49v8Zm14.08-8v31H69.63V91Zm19.9,0q7.27,0,11,4t3.71,11.45q0,7.36-3.71,11.43t-11,4.06H85.26V91Zm-1.55,23.19c2,0,3.38-.62,4.06-1.86a12.78,12.78,0,0,0,1-5.84,12.78,12.78,0,0,0-1-5.84c-.68-1.24-2-1.86-4.06-1.86H96.19v15.4ZM41.57,21.77a4.5,4.5,0,0,0-.51-6.2l-.29-.23a4.4,4.4,0,0,0-3.14-.86,4.45,4.45,0,0,0-2.9,1.5,1.79,1.79,0,0,0-.22.25,41.63,41.63,0,0,0-6.45,10.92A31.56,31.56,0,0,0,28,50.43a40.44,40.44,0,0,0,6.49,10.93,4.49,4.49,0,0,0,6.31.65h0a4.5,4.5,0,0,0,.65-6.32h0a31.57,31.57,0,0,1-5-8.36,22.93,22.93,0,0,1-1.65-8.51,23.32,23.32,0,0,1,1.71-8.56,32.39,32.39,0,0,1,5.08-8.49ZM22.4,7.54a1.37,1.37,0,0,0,.19-.23,4.45,4.45,0,0,0-.43-6.1,1.37,1.37,0,0,0-.22-.2,4.48,4.48,0,0,0-6.18.5A67.93,67.93,0,0,0,3.84,19.91,46.8,46.8,0,0,0,0,39,46.8,46.8,0,0,0,4.47,58,68.05,68.05,0,0,0,17,76.05l.11.11a4.48,4.48,0,0,0,6.23.08l.11-.1a4.56,4.56,0,0,0,1.31-3,4.48,4.48,0,0,0-1.22-3.21A59.49,59.49,0,0,1,12.72,54.48,38.08,38.08,0,0,1,9,38.89a38.45,38.45,0,0,1,3.23-15.72A59,59,0,0,1,22.4,7.54ZM81.31,21.77a4.5,4.5,0,0,1,.51-6.2l.28-.23a4.49,4.49,0,0,1,6.05.64,1.27,1.27,0,0,1,.21.25,41.4,41.4,0,0,1,6.46,10.92,31.56,31.56,0,0,1,.07,23.28A40.44,40.44,0,0,1,88.4,61.36a4.49,4.49,0,0,1-6.31.65h0a4.48,4.48,0,0,1-1.63-3,4.55,4.55,0,0,1,1-3.3h0a31.57,31.57,0,0,0,5-8.36,22.93,22.93,0,0,0,1.65-8.51,23.32,23.32,0,0,0-1.71-8.56,32.39,32.39,0,0,0-5.08-8.49ZM100.48,7.54a1.37,1.37,0,0,1-.19-.23,4.45,4.45,0,0,1,.43-6.1,1.37,1.37,0,0,1,.22-.2,4.48,4.48,0,0,1,6.18.5A67.93,67.93,0,0,1,119,19.91,46.8,46.8,0,0,1,122.87,39a46.8,46.8,0,0,1-4.46,19,68.05,68.05,0,0,1-12.52,18l-.11.11a4.48,4.48,0,0,1-6.23.08l-.11-.1a4.56,4.56,0,0,1-1.31-3,4.48,4.48,0,0,1,1.22-3.21,59.49,59.49,0,0,0,10.81-15.42,38.08,38.08,0,0,0,3.76-15.59,38.45,38.45,0,0,0-3.23-15.72A59,59,0,0,0,100.48,7.54Z" />
                  </svg>
                </div>
                <div @click="setConfirmationCharge(station, getSessionModalData.BespbLocationStatus)" :class="{ disabled: !stationStatus(station.StatusId, station.Type) }"
                  class="station_info_inner_right">
                  <span style="color: red; font-size: 14px; font-weight: 600; text-align: center; line-height: 1;" v-if="getSessionModalData.BespbLocationStatus && getSessionModalData.BespbLocationStatus === 'red'">
                    {{ $t("not_available") }}
                  </span>
                  <span class="start_charge_btn" v-html="$t('start_charge')" v-else-if="station.StatusId === 3 && station.Type === 'ac' || station.StatusId === 4 && station.Type === 'ac'">
                  </span>
                  <span class="start_charge_btn" v-html="$t('select_charge')" v-else-if="station.StatusId === 3 && station.Type === 'dc' || station.StatusId === 4 && station.Type === 'dc' || station.StatusId === 2 && station.Type === 'dc'">
                  </span>
                  <div v-else-if="station.StatusId === 2 && station.Type === 'ac'" class="status_active_charge">
                    <span>{{ $t("fully_occupied") }}</span>
                    <span v-if="getSessionModalData.Power">{{ stationCurrentPower(station.id) }} kW</span>
                  </div>
                  <span style="color: red; font-size: 14px; font-weight: 600; text-align: center; line-height: 1;" v-else>
                    {{ $t("not_available") }}
                  </span>
                </div>
              </div>
            </div>
            <div :class="{ red: !getGeoFound }" class="location_modal_bottom">
              <span v-if="getGeoFound">{{ $t("distance") }}:
                <strong>{{ Math.round(getSessionModalData.Distance) }}
                  {{ $t("km") }}</strong>
              </span>
              <span v-else> </span>
              <!-- <span v-else style="color: red">{{ $t("geo_not_found") }}</span> -->
              <div class="select_navigator">
                <div @click="
                  goRoute(
                    getSessionModalData.Corlat,
                    getSessionModalData.Corlng,
                    'google'
                  )
                " class="item google">
                  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="25.868mm" height="25.857mm"
                    version="1.1" style="
                        shape-rendering: geometricPrecision;
                        text-rendering: geometricPrecision;
                        image-rendering: optimizeQuality;
                        fill-rule: evenodd;
                        clip-rule: evenodd;
                      " viewBox="0 0 10999 10998" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Layer_x0020_1">
                      <metadata id="CorelCorpID_0Corel-Layer" />
                      <path class="fil0"
                        d="M1291 10998l7503 0c149,-52 394,-3 777,-310 32,-26 54,-49 82,-74 183,-161 380,-479 419,-836 23,-206 9,-2241 9,-2501l0 -1869c0,-148 17,-134 83,-229 359,-518 685,-1072 793,-1717l41 -288 0 -398 -11 -44c-2,-15 -3,-35 -5,-51 -3,-26 -6,-59 -10,-88 -8,-60 -17,-117 -28,-174 -22,-111 -49,-221 -81,-323 -127,-412 -325,-732 -581,-1050 -58,-72 -137,-142 -198,-205l-104 -97c-40,-37 -74,-65 -114,-97 -576,-474 -1564,-809 -2528,-567 -537,135 -845,319 -1217,607 -31,24 -86,70 -108,93 -156,168 -128,138 -275,138l-4078 0c-272,0 -488,-9 -731,76 -378,132 -679,422 -832,799 -97,240 -96,440 -96,719l0 6515c0,609 -51,939 250,1380 104,152 253,292 422,394 127,77 283,139 436,169 42,8 152,17 180,26zm6655 -8700c-352,44 -656,350 -608,761 41,351 358,653 761,605 486,-58 755,-569 521,-1016 -22,-42 -44,-69 -70,-104l-86 -88c-129,-96 -295,-185 -518,-157zm-3820 1370l-1374 0 0 458 784 0c-76,151 -218,274 -366,354 -523,283 -1211,-33 -1321,-653 -82,-468 188,-811 463,-965 160,-90 383,-134 598,-97 210,36 369,149 482,253l326 -323c-24,-39 -107,-102 -153,-136 -680,-518 -1779,-271 -2115,661 -124,345 -84,700 47,1013 59,140 178,311 273,395 39,34 22,31 119,110 434,352 1092,410 1587,94 32,-21 59,-39 87,-59l87 -69c56,-43 105,-100 150,-153 186,-215 317,-506 325,-885zm3818 5028c37,74 1007,994 1145,1157 18,-10 34,-24 48,-65 42,-123 29,-274 29,-411 0,-207 11,-2550 -4,-2636 -277,538 -401,845 -548,1434 -81,324 -261,569 -670,522zm-2499 -2487l494 493c167,167 328,328 495,495l742 742c50,50 200,214 254,245 -191,-859 -616,-1637 -1105,-2353l-211 -296c-41,26 -434,428 -504,498 -41,42 -146,130 -165,177zm-3863 3869l6433 4c-27,-52 -1562,-1571 -1601,-1610 -269,-270 -532,-532 -802,-802 -137,-137 -266,-267 -403,-403l-401 -404c-52,28 -2719,2711 -3027,3019 -52,52 -148,159 -199,197zm6438 -2914c22,-28 75,-178 94,-223 388,-928 731,-1448 1296,-2268 393,-571 742,-1158 660,-1911 -114,-1052 -988,-1843 -2050,-1843 -1440,0 -2514,1462 -1870,2934 231,528 683,1085 1001,1592 312,498 543,953 772,1491 19,45 75,202 97,229zm-7098 2254l1168 -1161c782,-773 1557,-1558 2338,-2335l879 -871c92,-92 211,-198 292,-293 -22,-51 -53,-93 -81,-145 -29,-53 -53,-98 -81,-148 -57,-102 -102,-210 -150,-317 -272,-606 -309,-1324 -135,-1966 34,-128 82,-231 119,-345 -220,-18 -513,-2 -740,-2l-2978 0c-206,0 -412,-16 -554,197 -111,165 -78,433 -78,664 0,308 -12,6630 4,6722z" />
                    </g>
                  </svg>
                </div>
                <div @click="
                  goRoute(
                    getSessionModalData.Corlat,
                    getSessionModalData.Corlng,
                    'apple'
                  )
                " class="item apple">
                  <svg id="Capa_1" style="enable-background: new 0 0 512 512" version="1.1" viewBox="0 0 512 512"
                    xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g>
                      <g>
                        <polygon points="135,275 105,346 135,336 165,346   " />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M407,0H105C47.103,0,0,47.103,0,105v302c0,57.897,47.103,105,105,105h302c57.897,0,105-47.103,105-105V105    C512,47.103,464.897,0,407,0z M74.999,36.282v81.143L35.197,77.623C42.47,59.143,56.867,44.229,74.999,36.282z M164.999,384.72    V482H105h-0.001v-97.282C78.538,373.121,60,346.691,60,316c0-30.691,18.538-57.121,44.999-68.718V30H105h59.999v217.28    C191.46,258.877,210,285.308,210,316C210,346.692,191.46,373.123,164.999,384.72z M434.377,476.803l-37.451-37.451    C382.069,447.416,365.06,452,347,452c-57.897,0-105-47.103-105-105c0-17.607,4.345-34.664,12.631-49.942l-59.633-59.633v-84.853    L317.8,275.374c6.939-3.127,13.422-7.307,19.195-12.475L347,253.944l10.004,8.956C370.765,275.217,388.52,282,407,282    c3.928,0,7.884-0.309,11.757-0.918l9.313-1.465l5.359,7.755C445.578,304.954,452,325.573,452,347    c0,18.06-4.584,35.068-12.648,49.926l37.451,37.451C469.182,453.739,453.739,469.182,434.377,476.803z M482,250.512    C363.614,243.084,268.916,148.386,261.488,30h75.213c7.111,76.944,68.355,138.188,145.299,145.299V250.512z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M420.677,333H273.323c-0.866,4.58-1.323,9.26-1.323,14c0,41.355,33.645,75,75,75c41.355,0,75-33.645,75-75    C422,342.26,421.543,337.58,420.677,333z" />
                      </g>
                    </g>
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                    <g />
                  </svg>
                </div>
                <div @click="
                  goRoute(
                    getSessionModalData.Corlat,
                    getSessionModalData.Corlng,
                    'waze'
                  )
                " class="item waze">
                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="25" height="25" viewBox="0 0 30 30"
                    style="fill: #000000">
                    <path
                      d="M 17.699219 4 C 12.699219 4 7.5996094 7.3007812 6.5996094 12.300781 C 5.9996094 15.300781 6.8007813 18.099609 4.3007812 18.099609 C 3.2007812 18.099609 2.4992187 19.400781 3.1992188 20.300781 C 4.5992187 22.200781 6.5003906 23.3 8.4003906 24 L 9.015625 24.246094 A 2.5 2.5 0 0 0 11.5 27 A 2.5 2.5 0 0 0 13.945312 25 L 17.900391 25 L 18.052734 25 A 2.5 2.5 0 0 0 20.5 27 A 2.5 2.5 0 0 0 22.871094 23.708984 C 27.060778 21.5787 29.388667 17.337865 28.599609 12.800781 C 27.999609 7.7007813 22.999219 4 17.699219 4 z M 17.699219 6 C 22.199219 6 26.200391 9.1007812 26.900391 13.300781 C 27.500391 16.900781 25.599609 20.399609 22.099609 22.099609 L 21.646484 22.28125 A 2.5 2.5 0 0 0 20.5 22 A 2.5 2.5 0 0 0 18.501953 23 C 18.501261 23 18.500692 23 18.5 23 L 18.099609 23 L 13.900391 23 C 13.778038 23 13.620854 22.984092 13.480469 22.978516 A 2.5 2.5 0 0 0 11.5 22 A 2.5 2.5 0 0 0 10.132812 22.410156 C 10.12233 22.406702 10.109976 22.403846 10.099609 22.400391 L 9.1992188 22.099609 C 7.7992187 21.599609 6.5996094 20.900391 5.5996094 19.900391 C 7.9996094 19.200391 8.2007812 16.400781 8.3007812 14.800781 C 8.4007812 14.100781 8.4 13.399219 8.5 12.699219 C 9.4 8.4992187 13.799219 6 17.699219 6 z M 14.5 11 A 1.5 1.5 0 0 0 14.5 14 A 1.5 1.5 0 0 0 14.5 11 z M 20.5 11 A 1.5 1.5 0 0 0 20.5 14 A 1.5 1.5 0 0 0 20.5 11 z M 13.605469 14.978516 C 13.542969 14.969141 13.475391 14.975 13.400391 15 C 13.100391 15.1 12.9 15.299609 13 15.599609 C 13.5 17.899609 15.7 19 17.5 19 C 19.3 19 21.5 17.899609 22 15.599609 C 22 15.299609 21.899609 15.1 21.599609 15 C 21.299609 15 21.1 15.100391 21 15.400391 C 20.6 17.200391 18.9 18 17.5 18 C 16.1 18 14.4 17.200391 14 15.400391 C 13.925 15.175391 13.792969 15.006641 13.605469 14.978516 z">
                    </path>
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <!-- ------2------ -->
          <div v-if="
            modalStatus === 2 &&
            confirmation_charge &&
            !activeSpinner &&
            !activeStationPopup
          " class="confirmation_charge">
            <!-- <div class="location_info">
              <span>
                <strong>
                  {{ getSessionModalData.Title.replace("amp;", "") }}
                </strong>
                <br />
                <small>{{ getSessionModalData.NetworkCity }}</small>
              </span>
            </div> -->
            <div class="confirm_block" style="margin-top: 0">
                <span v-if="checkLang() == 'ru' && this.socketsHasFreePort()">
                  Начать зарядку на станции <strong>{{ getSessionModalData.Title.replace("amp;", "") }} №{{confirmationCharge.id}}</strong>?
                </span>
                <span v-if="checkLang() == 'en' && this.socketsHasFreePort()">
                  Start charging at station <strong>{{ getSessionModalData.Title.replace("amp;", "") }} №{{confirmationCharge.id}}</strong>?
                </span>
                <span v-if="checkLang() == 'kz' && this.socketsHasFreePort()">
                  <strong>{{ getSessionModalData.Title.replace("amp;", "") }} №{{ confirmationCharge.id }}</strong> stansiasynda zarädtaudy bastaƞyz ba?
                </span>
                <span v-if="checkLang() == 'bg' && this.socketsHasFreePort()">
                  Стартираме ли зареждането на станция <strong>{{ getSessionModalData.Title.replace("amp;", "") }} №{{ confirmationCharge.id }}</strong>?
                </span>
                <span v-if="checkLang() == 'ru' && !this.socketsHasFreePort()">
                  <strong>Все порты заняты или недоступны</strong>
                </span>
                <span v-if="checkLang() == 'en' && !this.socketsHasFreePort()">
                  <strong>All ports are busy or unavailable</strong>
                </span>
                <span v-if="checkLang() == 'kz' && !this.socketsHasFreePort()">
                  <strong>Barlyq porttar bos emes nemese qoljetımsız</strong>
                </span>
                <span v-if="checkLang() == 'bg' && !this.socketsHasFreePort()">
                  <strong>Всички портове са заети или недостъпни</strong>
                </span>
              <button v-if="this.prepareChargeData.Maxkwh < 1" @click="setBalancePage()">
                {{ $t("top_up_balance") }} 
              </button>
              <!-- TODO: костыль для бэка, бизи не равен что порт занят, подстраховка мощностью -->
              <div class="prepared_sockets" :class="{disabled: socket.Busy == 1 || Number(socket.Power) > 0}" v-else-if="this.prepareChargeData.Type == 'dc' && this.prepareChargeData.Maxkwh > 1" v-for="socket in this.prepareChargeData.Sockets" :key="socket.SocketId">
                <label :for="'plug-type-' + socket.SocketId">
                  <div class="prepared_sockets-radio">
                    <input :id="'plug-type-' + socket.SocketId" :disabled="socket.Busy == 1 || Number(socket.Percent) > 0 || Number(socket.Power) > 0" v-model="checkedDc" type="radio" name="plug-type" :value="socket.SocketId">
                  </div>
                  <div class="prepared_sockets-img">
                    <img v-if="socket.Type === 'chademo'" src="images/plug-chademo.svg" />
                    <img v-else-if="socket.Type === 'ccs2'" src="images/plug-ccs2.svg" />
                    <img v-else-if="socket.Type === 'ccs'" src="images/plug-ccs2.svg" />
                    <img v-else-if="socket.Type === 'type2'" src="images/plug-type2.svg" />
                    <img v-else-if="socket.Type === 'type1'" src="images/plug-type1.svg" />
                    <img v-else src="images/plug-shuko.svg" />
                  </div>
                  <div class="prepared_sockets-plug-type-name">
                    {{ socket.SocketId }}   {{ getSocketTypeName(socket) }}
                  </div>
                  <!-- <div v-if="Number(socket.Percent) === 0 && Number(socket.Power) === 0 && socket.Busy == 1" class="prepared_sockets-plug-power" style="padding: 0; margin-left: 3px; font-weight: 600; font-size: 15px;"> -->
                  <div class="prepared_sockets-plug-power" style="padding: 0; margin-left: 3px; font-weight: 600; font-size: 15px;">
                     {{ getPrepareDetails(socket) }}
                  </div>
                  <div v-if="socket.Percent && socket.Percent > 0" class="prepared_sockets-plug-percent">
                    {{ socket.Percent }}%
                  </div>
                  <div v-if="socket.Power && socket.Power > 0" class="prepared_sockets-plug-power">
                    {{ (parseInt(socket.Power)).toFixed(0) }}kW
                  </div>
                  <!-- <div v-if="socket.Percent == 0 && socket.Power == 0" class="prepared_sockets-plug-power" style="margin-left: auto; padding-left: 5px;">
                    {{ dirkaStatus(socket) }}
                  </div> -->
                </label>
              </div>
              <div v-if="this.prepareChargeData.Maxkwh > 1 && this.socketsHasFreePort()" class="prepared_sockets-btn">
                  <button :class="{disabled: !this.socketsHasFreePort()}" :disabled="!this.socketsHasFreePort()" style="text-transform: uppercase;" @click="setActivatedCharge()">
                    <!-- {{ $t("confirm_start") }} -->
                    {{ $t("start_charge1") }}
                  </button>
              </div>
              <div style="display: flex; justify-content: center;">
                <strong>{{ $t("cost") }}: {{ getSessionModalData.Price }} BGN {{ $t("za") }} 1 kWh</strong>
              </div>
            </div>
          </div>

          <!-- ------3------ -->
          <div v-if="
            modalStatus === 3 &&
            activated_charge &&
            !activeSpinner &&
            !activeStationPopup
          " class="activated_charge">
            <div class="location_info">
              <span v-if="getAccountInfo.Sessions.Location" class="location_title">
                <strong>{{ getAccountInfo.Sessions.Location }}</strong>
                <strong> №{{ getAccountInfo.Sessions.Unid }}</strong>
                <br />
                <small>
                  {{ getAccountInfo.Sessions.City }}
                </small>
              </span>
            </div>
            <div class="activated_charge_inner">
              <img src="/images/new_spinner.gif" alt="" />
              <p style="text-align: center; margin-top: 20px; font-size: 1rem">
                {{ $t("connect_the_car") }}
              </p>
            </div>
          </div>

          <!-- ------4------ -->
          <div v-if="
            started_charge &&
            modalStatus === 4 &&
            !activeSpinner &&
            !activeStationPopup
          " class="started_charge">
            <div v-if="getReconnectSocket === true" class="reconnect_spinner">
              <img style="max-width: 100px" src="/images/new_spinner.gif" alt="" />
            </div>
            <div v-else>
              <div class="location_info">
                <div class="row1">
                  <div class="left">
                    <span class="location_title">
                      <strong>{{
                        getSessionModalData.Title.replace("amp;", "")
                      }}</strong>
                      <strong v-if="
                        getAccountInfo.Sessions !== null &&
                        getAccountInfo.Sessions !== ''
                      ">
                        №{{ getAccountInfo.Sessions.Unid }}</strong>
                      <br />
                      <small>{{ getSessionModalData.NetworkCity }}</small>
                    </span>
                  </div>
                  <div class="right">
                    <div class="gps">
                      <svg version="1.1" height="20" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.883 477.883"
                        style="enable-background: new 0 0 477.883 477.883" xml:space="preserve">
                        <path fill="#808080" d="M468.456,1.808c-4.811-2.411-10.478-2.411-15.289,0l0,0L9.433,223.675c-8.429,4.219-11.842,14.471-7.624,22.9
                            c2.401,4.798,6.919,8.188,12.197,9.151l176.111,32.034l32.034,176.111c1.311,7.219,7.091,12.793,14.353,13.841
                            c0.803,0.116,1.613,0.173,2.423,0.171c6.469,0.003,12.383-3.651,15.275-9.438L476.07,24.711
                            C480.292,16.284,476.883,6.03,468.456,1.808z M246.557,407.38l-24.986-137.353c-1.292-6.936-6.718-12.362-13.653-13.653
                            L70.498,231.32L422.634,55.244L246.557,407.38z" />
                      </svg>
                    </div>
                    <div @click="
                      toggleFavorite(
                        getSessionModalData.Bookmark,
                        getSessionModalData.Key
                      )
                    " :class="{ favorite: getSessionModalData.Bookmark > 0 }" class="heart">
                      <svg version="1.1" height="20" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 485 485"
                        style="enable-background: new 0 0 485 485" xml:space="preserve">
                        <path fill="#808080" d="M343.611,22.543c-22.613,0-44.227,5.184-64.238,15.409c-13.622,6.959-26.136,16.205-36.873,27.175
                            c-10.738-10.97-23.251-20.216-36.873-27.175c-20.012-10.225-41.625-15.409-64.239-15.409C63.427,22.543,0,85.97,0,163.932
                            c0,55.219,29.163,113.866,86.678,174.314c48.022,50.471,106.816,92.543,147.681,118.95l8.141,5.261l8.141-5.261
                            c40.865-26.406,99.659-68.479,147.682-118.95C455.838,277.798,485,219.151,485,163.932C485,85.97,421.573,22.543,343.611,22.543z
                             M376.589,317.566c-42.918,45.106-95.196,83.452-134.089,109.116c-38.893-25.665-91.171-64.01-134.088-109.116
                            C56.381,262.884,30,211.194,30,163.932c0-61.42,49.969-111.389,111.389-111.389c35.361,0,67.844,16.243,89.118,44.563
                            l11.993,15.965l11.993-15.965c21.274-28.32,53.757-44.563,89.118-44.563c61.42,0,111.389,49.969,111.389,111.389
                            C455,211.194,428.618,262.884,376.589,317.566z" />
                      </svg>
                    </div>
                    <div v-if="
                      this.$store.getters.getIsMobile && webShareApiSupported
                    " class="share" @click="share_station(getSessionModalData)">
                      <svg fill="none" height="24" stroke="#808080" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="18" cy="5" r="3" />
                        <circle cx="6" cy="12" r="3" />
                        <circle cx="18" cy="19" r="3" />
                        <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
                        <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div v-if="getAccountInfo.Sessions.Status" class="row11">
                  <span class="charge_status">
                    <strong>{{ getChargeStatus(getSocketData.Data.Import) }}</strong>
                  </span>
                </div>
                <div v-if="getSessionModalData.Hours !== '' || getGeoFound" class="row2">
                  <div v-if="getGeoFound" class="distance">
                    <span>{{ $t("distance") }}:
                      <strong>{{ Math.round(getSessionModalData.Distance) }}
                        {{ $t("km") }}</strong>
                    </span>
                  </div>
                  <!-- <hr />
                  <div v-if="getSessionModalData.Hours !== ''" class="worktime">
                    <svg id="Capa_1" enable-background="new 0 0 443.294 443.294" height="15" viewBox="0 0 443.294 443.294"
                      xmlns="http://www.w3.org/2000/svg">
                      <path fill="#808080"
                        d="m221.647 0c-122.214 0-221.647 99.433-221.647 221.647s99.433 221.647 221.647 221.647 221.647-99.433 221.647-221.647-99.433-221.647-221.647-221.647zm0 415.588c-106.941 0-193.941-87-193.941-193.941s87-193.941 193.941-193.941 193.941 87 193.941 193.941-87 193.941-193.941 193.941z" />
                      <path fill="#808080" d="m235.5 83.118h-27.706v144.265l87.176 87.176 19.589-19.589-79.059-79.059z" />
                    </svg>
                    <strong><span>{{ getSessionModalData.Hours }}</span></strong>
                  </div> -->
                </div>
              </div>
              <div class="started_charge_inner">
                <div class="data" v-if="getReconnectSocket === false">
                  <div class="flex_row">
                    <div class="flex_column">
                      {{ $t("active_session_popup.session_time") }}
                    </div>
                    <div class="flex_column">
                      {{ removeSeconds(getSocketData.Data._duration) }}
                    </div>
                  </div>
                  <div class="flex_row">
                    <div class="flex_column">
                      {{ $t("current_power") }}
                    </div>
                    <div class="flex_column">
                      {{ (getSocketData.Data.Power && getSocketData.Data.Power != '0' && getSocketData.Data.Power != 0) ? `${getSocketData.Data.Power} kW` : '' }}
                    </div>
                  </div>
                  <div class="flex_row">
                    <div class="flex_column">
                      {{ $t("consumed_energy") }}
                    </div>
                    <div class="flex_column">
                      {{ getSocketData.Data.Import }} {{ $t("iz") }} {{ getAvailablePower(getSessionModalData.Price) }} kWh
                    </div>
                  </div>
                  <div v-if="getSocketData.Data.Cost" class="flex_row">
                    <div class="flex_column">
                      {{ $t("cost") }}
                    </div>
                    <div class="flex_column">
                      {{ (getSocketData.Data.Cost).toFixed(2) }} BGN
                    </div>
                  </div>
                  <div v-if="this.getAccountInfo.Sessions.Status == 'PAUSED'" class="flex_row" style="flex-direction: column">
                    <div class="tech_title" style="color:red!important;">
                        {{ $t("tech_details_paused") }}
                    </div>
                  </div>
                  <div v-else class="flex_row" style="flex-direction: column">
                    <div style="cursor: pointer" @click="techDataDC = !techDataDC, techDataAC = !techDataAC" v-if="getSocketData.Data.Type === 'dc' && getSocketData.Data.V1 > 0 || getSocketData.Data.Type === 'ac'" class="tech_title">
                      <div v-if="techDataDC && getSocketData.Data.Type === 'dc'"><b>{{ $t("tech_details") }} ({{ $t("hide") }})</b></div>
                      <div v-if="!techDataDC && getSocketData.Data.Type === 'dc'"><b>{{ $t("tech_details") }} ({{ $t("show") }})</b></div>
                      <div v-if="techDataAC && getSocketData.Data.Type === 'ac'"><b>{{ $t("tech_details") }} ({{ $t("hide") }})</b></div>
                      <div v-if="!techDataAC && getSocketData.Data.Type === 'ac'"><b>{{ $t("tech_details") }} ({{ $t("show") }})</b></div>
                    </div>
                    <div v-if="techDataDC && getSocketData.Data.Type === 'dc' && getSocketData.Data.V1 > 0" class="tech_data" style="
                          display: flex;
                          flex-direction: column;
                          position: relative;
                        ">
                      <img class="gear_img" src="/images/gear.png" alt="" />
                      <span class="1_faza">DC: {{ getSocketData.Data.Percent }}%&nbsp;{{ getSocketData.Data.V1 }}V&nbsp;{{((getSocketData.Data.P1 * 1000)/getSocketData.Data.V1).toFixed(2)}}A</span>
                    </div>
                    <div v-if="techDataAC && getSocketData.Data.Type === 'ac'" class="tech_data" style="
                          display: flex;
                          flex-direction: column;
                          position: relative;
                        ">
                      <img class="gear_img" src="/images/gear.png" alt="" />
                      <span class="1_faza">
                        {{ $t("1_phase") }}: {{ getSocketData.Data.V1 }} V /
                        {{
                          (
                            (getSocketData.Data.P1 * 1000) /
                            getSocketData.Data.V1
                          ).toFixed(2)
                        }}
                        A
                      </span>
                      <span v-if="getSocketData.Data.P2 > 0.05" class="2_faza">
                        {{ $t("2_phase") }}: {{ getSocketData.Data.V2 }} V /
                        {{
                          (
                            (getSocketData.Data.P2 * 1000) /
                            getSocketData.Data.V2
                          ).toFixed(2)
                        }}
                        A
                      </span>
                      <span v-if="getSocketData.Data.P3 > 0.05" class="3_faza">
                        {{ $t("3_phase") }}: {{ getSocketData.Data.V3 }} V /
                        {{
                          (
                            (getSocketData.Data.P3 * 1000) /
                            getSocketData.Data.V3
                          ).toFixed(2)
                        }}
                        A
                      </span>
                    </div>
                  </div>
                </div>
                <button :disabled="isBlockStopCharge(getSocketData.Data._duration)" v-bind:class="{disabled: isBlockStopCharge(getSocketData.Data._duration)}" class="finish_charge" @click="stopCharge()">
                  {{ $t("finish_charge") }}
                </button>
              </div>
              <div v-if="!sessionIsMoreThanTwoMinutes(getSocketData.Data)" class="tariff">
                <strong>{{ $t("plugshare_time") }}</strong>
              </div>
              <div v-else-if="getSessionModalData.Price" class="tariff">
                <strong>{{ getSessionModalData.Price }} BGN {{ $t("za") }} 1 kWh</strong>
              </div>
            </div>
          </div>

          <!-- ------5------ -->
          <div v-if="finished_charge()" class="finished_charge">
            <div class="finished_charge_inner">
              <div class="charge_location">
                <strong>{{ $t("charge_finished") }}</strong><br />
                <span class="location_title">
                  {{ getSocketFinishedData.Data.Comment }}
                </span>
              </div>
              <div class="data">
                <div class="flex_row">
                  <div class="flex_column">
                    {{ $t("active_session_popup.session_time") }}
                  </div>
                  <div class="flex_column">
                    {{ getSocketFinishedData.Data._duration }}
                  </div>
                </div>
                <div class="flex_row">
                  <div class="flex_column">
                    {{ $t("consumed_energy") }}
                  </div>
                  <div class="flex_column">
                    {{ getSocketFinishedData.Data.Import }} kWh
                  </div>
                </div>
                <div class="flex_row">
                  <div class="flex_column">
                    {{ $t("cost") }}
                  </div>
                  <div class="flex_column">
                    {{ (getSocketFinishedData.Data.Cost).toFixed(2) }} BGN
                  </div>
                </div>
              </div>
            </div>
            <!-- <div v-if="getSessionModalData.Price" class="tariff">
              <strong>{{ getSessionModalData.Price }} BGN {{ $t("za") }} 1
                kWh</strong>
            </div> -->
            <div class="tariff">
              {{ $t("plugshare1") }} <strong>PlugShare</strong> {{ $t("plugshare2") }}
            </div>
          </div>

          <!-- ------Active station popup with socket data------ -->
          <div v-if="
            activeStationPopup &&
            !activeSpinner &&
            this.$store.getters.getSocketFinishedData === null &&
            this.getSocketData !== null
          " class="started_charge">
            <div v-if="getReconnectSocket === true" class="reconnect_spinner">
              <img style="max-width: 100px" src="/images/new_spinner.gif" alt="" />
            </div>
            <div v-else>
              <div class="location_info">
                <div class="row1">
                  <div class="left">
                    <span class="location_title">
                      <strong>{{
                        getSessionModalData.Title.replace("amp;", "")
                      }}</strong>
                      <strong v-if="
                        getAccountInfo.Sessions !== null &&
                        getAccountInfo.Sessions !== ''
                      ">
                        #{{ getAccountInfo.Sessions.Unid }}</strong>
                      <br />
                      <small>{{ getSessionModalData.NetworkCity }}</small></span>
                  </div>
                  <div class="right">
                    <div @click="
                      goRoute(
                        getSessionModalData.Corlat,
                        getSessionModalData.Corlng
                      )
                    " class="gps">
                      <svg version="1.1" height="20" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.883 477.883"
                        style="enable-background: new 0 0 477.883 477.883" xml:space="preserve">
                        <path fill="#808080" d="M468.456,1.808c-4.811-2.411-10.478-2.411-15.289,0l0,0L9.433,223.675c-8.429,4.219-11.842,14.471-7.624,22.9
                            c2.401,4.798,6.919,8.188,12.197,9.151l176.111,32.034l32.034,176.111c1.311,7.219,7.091,12.793,14.353,13.841
                            c0.803,0.116,1.613,0.173,2.423,0.171c6.469,0.003,12.383-3.651,15.275-9.438L476.07,24.711
                            C480.292,16.284,476.883,6.03,468.456,1.808z M246.557,407.38l-24.986-137.353c-1.292-6.936-6.718-12.362-13.653-13.653
                            L70.498,231.32L422.634,55.244L246.557,407.38z" />
                      </svg>
                    </div>
                    <div @click="
                      toggleFavorite(
                        getSessionModalData.Bookmark,
                        getSessionModalData.Key
                      )
                    " :class="{ favorite: getSessionModalData.Bookmark > 0 }" class="heart">
                      <svg version="1.1" height="20" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 485 485"
                        style="enable-background: new 0 0 485 485" xml:space="preserve">
                        <path fill="#808080" d="M343.611,22.543c-22.613,0-44.227,5.184-64.238,15.409c-13.622,6.959-26.136,16.205-36.873,27.175
                            c-10.738-10.97-23.251-20.216-36.873-27.175c-20.012-10.225-41.625-15.409-64.239-15.409C63.427,22.543,0,85.97,0,163.932
                            c0,55.219,29.163,113.866,86.678,174.314c48.022,50.471,106.816,92.543,147.681,118.95l8.141,5.261l8.141-5.261
                            c40.865-26.406,99.659-68.479,147.682-118.95C455.838,277.798,485,219.151,485,163.932C485,85.97,421.573,22.543,343.611,22.543z
                             M376.589,317.566c-42.918,45.106-95.196,83.452-134.089,109.116c-38.893-25.665-91.171-64.01-134.088-109.116
                            C56.381,262.884,30,211.194,30,163.932c0-61.42,49.969-111.389,111.389-111.389c35.361,0,67.844,16.243,89.118,44.563
                            l11.993,15.965l11.993-15.965c21.274-28.32,53.757-44.563,89.118-44.563c61.42,0,111.389,49.969,111.389,111.389
                            C455,211.194,428.618,262.884,376.589,317.566z" />
                      </svg>
                    </div>
                    <div v-if="
                      this.$store.getters.getIsMobile && webShareApiSupported
                    " class="share" @click="share_station(getSessionModalData)">
                      <svg fill="none" height="24" stroke="#808080" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="18" cy="5" r="3" />
                        <circle cx="6" cy="12" r="3" />
                        <circle cx="18" cy="19" r="3" />
                        <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
                        <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div v-if="getAccountInfo.Sessions.Status" class="row11">
                  <span class="charge_status">
                    <strong>{{ getChargeStatus(getSocketData.Data.Import) }}</strong>
                  </span>
                </div>
                <div v-if="getSessionModalData.Hours !== '' || getGeoFound" class="row2">
                  <div v-if="getGeoFound" class="distance">
                    <span>{{ $t("distance") }}:
                      <strong>{{ Math.round(getSessionModalData.Distance) }}
                        {{ $t("km") }}</strong>
                    </span>
                  </div>
                  <!-- <hr />
                  <div v-if="getSessionModalData.Hours !== ''" class="worktime">
                    <svg id="Capa_1" enable-background="new 0 0 443.294 443.294" height="15" viewBox="0 0 443.294 443.294"
                      xmlns="http://www.w3.org/2000/svg">
                      <path fill="#808080"
                        d="m221.647 0c-122.214 0-221.647 99.433-221.647 221.647s99.433 221.647 221.647 221.647 221.647-99.433 221.647-221.647-99.433-221.647-221.647-221.647zm0 415.588c-106.941 0-193.941-87-193.941-193.941s87-193.941 193.941-193.941 193.941 87 193.941 193.941-87 193.941-193.941 193.941z" />
                      <path fill="#808080" d="m235.5 83.118h-27.706v144.265l87.176 87.176 19.589-19.589-79.059-79.059z" />
                    </svg>
                    <strong><span>{{ getSessionModalData.Hours }}</span></strong>
                  </div> -->
                </div>
              </div>
              <div class="started_charge_inner">
                <div class="data" v-if="getReconnectSocket === false">
                  <div class="flex_row">
                    <div class="flex_column">
                      {{ $t("active_session_popup.session_time") }}
                    </div>
                    <div class="flex_column">
                      {{ removeSeconds(getSocketData.Data._duration) }}
                    </div>
                  </div>
                  <div class="flex_row">
                    <div class="flex_column">
                      {{ $t("current_power") }}
                    </div>
                    <div class="flex_column">
                      {{ getSocketData.Data.Power }} kW
                    </div>
                  </div>
                  <div class="flex_row">
                    <div class="flex_column">
                      {{ $t("consumed_energy") }}
                    </div>
                    <div class="flex_column">
                      {{ getSocketData.Data.Import }} {{ $t("iz") }} {{ getAvailablePower(getSessionModalData.Price) }} kWh
                    </div>
                  </div>
                  <div v-if="getSocketData.Data.Cost" class="flex_row">
                    <div class="flex_column">
                      {{ $t("cost") }}
                    </div>
                    <div class="flex_column">
                      {{ (getSocketData.Data.Cost).toFixed(2) }} BGN
                    </div>
                  </div>
                  <div v-if="this.getAccountInfo.Sessions.Status == 'PAUSED'" class="flex_row" style="flex-direction: column">
                    <div class="tech_title" style="color:red!important;">
                        {{ $t("tech_details_paused") }}
                    </div>
                  </div>
                  <div v-else class="flex_row" style="flex-direction: column">
                    <div style="cursor: pointer" @click="techDataAC = !techDataAC, techDataDC = !techDataDC" v-if="getSocketData.Data.Type === 'dc' && getSocketData.Data.V1 > 0 || getSocketData.Data.Type === 'ac'" class="tech_title">
                      <div v-if="techDataDC && getSocketData.Data.Type === 'dc'"><b>{{ $t("tech_details") }} ({{ $t("hide") }})</b></div>
                      <div v-if="!techDataDC && getSocketData.Data.Type === 'dc'"><b>{{ $t("tech_details") }} ({{ $t("show") }})</b></div>
                      <div v-if="techDataAC && getSocketData.Data.Type === 'ac'"><b>{{ $t("tech_details") }} ({{ $t("hide") }})</b></div>
                      <div v-if="!techDataAC && getSocketData.Data.Type === 'ac'"><b>{{ $t("tech_details") }} ({{ $t("show") }})</b></div>
                    </div>
                    <div v-if="techDataDC && getSocketData.Data.Type === 'dc' && getSocketData.Data.V1 > 0" class="tech_data" style="
                          display: flex;
                          flex-direction: column;
                          position: relative;
                        ">
                      <img class="gear_img" src="/images/gear.png" alt="" />
                      <span class="1_faza">DC: {{ getSocketData.Data.Percent }}%&nbsp;{{ getSocketData.Data.V1 }}V&nbsp;{{((getSocketData.Data.P1 * 1000)/getSocketData.Data.V1).toFixed(2)}}A</span>
                    </div>
                    <div v-if="techDataAC && getSocketData.Data.Type === 'ac'" class="tech_data" style="
                          display: flex;
                          flex-direction: column;
                          position: relative;
                        ">
                      <img class="gear_img" src="/images/gear.png" alt="" />
                      <span class="1_faza">
                        {{ $t("1_phase") }}: {{ getSocketData.Data.V1 }} V /
                        {{
                          (
                            (getSocketData.Data.P1 * 1000) /
                            getSocketData.Data.V1
                          ).toFixed(2)
                        }}
                        A
                      </span>
                      <span v-if="getSocketData.Data.P2 > 0.05" class="2_faza">
                        {{ $t("2_phase") }}: {{ getSocketData.Data.V2 }} V /
                        {{
                          (
                            (getSocketData.Data.P2 * 1000) /
                            getSocketData.Data.V2
                          ).toFixed(2)
                        }}
                        A
                      </span>
                      <span v-if="getSocketData.Data.P3 > 0.05" class="3_faza">
                        {{ $t("3_phase") }}: {{ getSocketData.Data.V3 }} V /
                        {{
                          (
                            (getSocketData.Data.P3 * 1000) /
                            getSocketData.Data.V3
                          ).toFixed(2)
                        }}
                        A
                      </span>
                    </div>
                  </div>
                </div>
                <button class="finish_charge" v-bind:class="{disabled: isBlockStopCharge(getSocketData.Data._duration)}" :disabled="isBlockStopCharge(getSocketData.Data._duration)" @click="stopCharge()">
                  {{ $t("finish_charge") }}
                </button>
              </div>
              <div v-if="!sessionIsMoreThanTwoMinutes(getSocketData.Data)" class="tariff">
                <strong>{{ $t("plugshare_time") }}</strong>
              </div>
              <div v-else-if="getSessionModalData.Price" class="tariff">
                <strong>{{ getSessionModalData.Price }} BGN {{ $t("za") }} 1 kWh</strong>
              </div>
            </div>
          </div>

          <!-- ------Active station popup with detach data------ -->
          <div v-if="
            activeStationPopup &&
            !activeSpinner &&
            this.detach_check &&
            this.getSocketData == null
          " class="started_charge">
            <div v-if="getReconnectSocket === true" class="reconnect_spinner">
              <img style="max-width: 100px" src="/images/new_spinner.gif" alt="" />
            </div>
            <div v-else>
              <div class="location_info">
                <div class="row1">
                  <div class="left">
                    <span class="location_title">
                      <strong>{{
                        getSessionModalData.Title.replace("amp;", "")
                      }}</strong>
                      <strong v-if="
                        getAccountInfo.Sessions !== null &&
                        getAccountInfo.Sessions !== ''
                      ">
                        #{{ getAccountInfo.Sessions.Unid }}</strong>
                      <br />
                      <small>{{ getSessionModalData.NetworkCity }}</small></span>
                  </div>
                  <div class="right">
                    <div @click="
                      goRoute(
                        getSessionModalData.Corlat,
                        getSessionModalData.Corlng
                      )
                    " class="gps">
                      <svg version="1.1" height="20" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.883 477.883"
                        style="enable-background: new 0 0 477.883 477.883" xml:space="preserve">
                        <path fill="#808080" d="M468.456,1.808c-4.811-2.411-10.478-2.411-15.289,0l0,0L9.433,223.675c-8.429,4.219-11.842,14.471-7.624,22.9
                            c2.401,4.798,6.919,8.188,12.197,9.151l176.111,32.034l32.034,176.111c1.311,7.219,7.091,12.793,14.353,13.841
                            c0.803,0.116,1.613,0.173,2.423,0.171c6.469,0.003,12.383-3.651,15.275-9.438L476.07,24.711
                            C480.292,16.284,476.883,6.03,468.456,1.808z M246.557,407.38l-24.986-137.353c-1.292-6.936-6.718-12.362-13.653-13.653
                            L70.498,231.32L422.634,55.244L246.557,407.38z" />
                      </svg>
                    </div>
                    <div @click="
                      toggleFavorite(
                        getSessionModalData.Bookmark,
                        getSessionModalData.Key
                      )
                    " :class="{ favorite: getSessionModalData.Bookmark > 0 }" class="heart">
                      <svg version="1.1" height="20" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 485 485"
                        style="enable-background: new 0 0 485 485" xml:space="preserve">
                        <path fill="#808080" d="M343.611,22.543c-22.613,0-44.227,5.184-64.238,15.409c-13.622,6.959-26.136,16.205-36.873,27.175
                            c-10.738-10.97-23.251-20.216-36.873-27.175c-20.012-10.225-41.625-15.409-64.239-15.409C63.427,22.543,0,85.97,0,163.932
                            c0,55.219,29.163,113.866,86.678,174.314c48.022,50.471,106.816,92.543,147.681,118.95l8.141,5.261l8.141-5.261
                            c40.865-26.406,99.659-68.479,147.682-118.95C455.838,277.798,485,219.151,485,163.932C485,85.97,421.573,22.543,343.611,22.543z
                             M376.589,317.566c-42.918,45.106-95.196,83.452-134.089,109.116c-38.893-25.665-91.171-64.01-134.088-109.116
                            C56.381,262.884,30,211.194,30,163.932c0-61.42,49.969-111.389,111.389-111.389c35.361,0,67.844,16.243,89.118,44.563
                            l11.993,15.965l11.993-15.965c21.274-28.32,53.757-44.563,89.118-44.563c61.42,0,111.389,49.969,111.389,111.389
                            C455,211.194,428.618,262.884,376.589,317.566z" />
                      </svg>
                    </div>
                    <div v-if="
                      this.$store.getters.getIsMobile && webShareApiSupported
                    " class="share" @click="share_station(getSessionModalData)">
                      <svg fill="none" height="24" stroke="#808080" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="18" cy="5" r="3" />
                        <circle cx="6" cy="12" r="3" />
                        <circle cx="18" cy="19" r="3" />
                        <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
                        <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div v-if="getAccountInfo.Sessions.Status" class="row11">
                  <span class="charge_status">
                    <strong>{{ getChargeStatus(this.getAccountInfo.Sessions.Import) }}</strong>
                  </span>
                </div>
                <div v-if="getSessionModalData.Hours !== '' || getGeoFound" class="row2">
                  <div v-if="getGeoFound" class="distance">
                    <span>{{ $t("distance") }}:
                      <strong>{{ Math.round(getSessionModalData.Distance) }}
                        {{ $t("km") }}</strong>
                    </span>
                  </div>
                  <!-- <hr />
                  <div v-if="getSessionModalData.Hours !== ''" class="worktime">
                    <svg id="Capa_1" enable-background="new 0 0 443.294 443.294" height="15" viewBox="0 0 443.294 443.294"
                      xmlns="http://www.w3.org/2000/svg">
                      <path fill="#808080"
                        d="m221.647 0c-122.214 0-221.647 99.433-221.647 221.647s99.433 221.647 221.647 221.647 221.647-99.433 221.647-221.647-99.433-221.647-221.647-221.647zm0 415.588c-106.941 0-193.941-87-193.941-193.941s87-193.941 193.941-193.941 193.941 87 193.941 193.941-87 193.941-193.941 193.941z" />
                      <path fill="#808080" d="m235.5 83.118h-27.706v144.265l87.176 87.176 19.589-19.589-79.059-79.059z" />
                    </svg>
                    <strong><span>{{ getSessionModalData.Hours }}</span></strong>
                  </div> -->
                </div>
              </div>
              <div class="started_charge_inner">
                <div class="data" v-if="getReconnectSocket === false">
                  <div class="flex_row">
                    <div class="flex_column">
                      {{ $t("active_session_popup.session_time") }}
                    </div>
                    <div class="flex_column">
                      {{ this.getAccountInfo.Sessions._duration }}
                    </div>
                  </div>
                  <div class="flex_row">
                    <div class="flex_column">
                      {{ $t("current_power") }}
                    </div>
                    <div class="flex_column">
                      {{ this.getAccountInfo.Sessions.Power }} kW
                    </div>
                  </div>
                  <div class="flex_row">
                    <div class="flex_column">
                      {{ $t("consumed_energy") }}
                    </div>
                    <div class="flex_column">
                      {{ this.getAccountInfo.Sessions.Import }} kWh
                    </div>
                  </div>
                  <div class="flex_row">
                    <div class="flex_column">
                      {{ $t("cost") }}
                    </div>
                    <div class="flex_column">
                      {{ (this.getAccountInfo.Sessions.Cost).toFixed(2) }} BGN
                    </div>
                  </div>
                  <div v-if="this.getAccountInfo.Sessions.Status == 'PAUSED'" class="flex_row" style="flex-direction: column">
                    <div class="tech_title" style="color:red!important;">
                        <b>{{ $t("tech_details_paused") }}</b>
                    </div>
                  </div>
                  <div v-else class="flex_row" style="flex-direction: column">
                    <div style="cursor: pointer" @click="techDataAC = !techDataAC, techDataDC = !techDataDC" v-if="getSocketData.Data.Type === 'dc' && getSocketData.Data.V1 > 0 || getSocketData.Data.Type === 'ac'" class="tech_title">
                      <div v-if="techDataDC && getSocketData.Data.Type === 'dc'"><b>{{ $t("tech_details") }} ({{ $t("hide") }})</b></div>
                      <div v-if="!techDataDC && getSocketData.Data.Type === 'dc'"><b>{{ $t("tech_details") }} ({{ $t("show") }})</b></div>
                      <div v-if="techDataAC && getSocketData.Data.Type === 'ac'"><b>{{ $t("tech_details") }} ({{ $t("hide") }})</b></div>
                      <div v-if="!techDataAC && getSocketData.Data.Type === 'ac'"><b>{{ $t("tech_details") }} ({{ $t("show") }})</b></div>
                    </div>
                    <div v-if="techDataDC && getSocketData.Data.Type === 'dc' && getSocketData.Data.V1 > 0" class="tech_data" style="
                          display: flex;
                          flex-direction: column;
                          position: relative;
                        ">
                      <img class="gear_img" src="/images/gear.png" alt="" />
                      <span class="1_faza">DC: {{ getSocketData.Data.Percent }}%&nbsp;{{ getSocketData.Data.V1 }}V&nbsp;{{((getSocketData.Data.P1 * 1000)/getSocketData.Data.V1).toFixed(2)}}A</span>
                    </div>
                    <div v-if="techDataAC && getSocketData.Data.Type === 'ac'" class="tech_data" style="
                          display: flex;
                          flex-direction: column;
                          position: relative;
                        ">
                      <img class="gear_img" src="/images/gear.png" alt="" />
                      <span class="1_faza">
                        {{ $t("1_phase") }}: {{ getSocketData.Data.V1 }} V /
                        {{
                          (
                            (getSocketData.Data.P1 * 1000) /
                            getSocketData.Data.V1
                          ).toFixed(2)
                        }}
                        A
                      </span>
                      <span v-if="getSocketData.Data.P2 > 0.05" class="2_faza">
                        {{ $t("2_phase") }}: {{ getSocketData.Data.V2 }} V /
                        {{
                          (
                            (getSocketData.Data.P2 * 1000) /
                            getSocketData.Data.V2
                          ).toFixed(2)
                        }}
                        A
                      </span>
                      <span v-if="getSocketData.Data.P3 > 0.05" class="3_faza">
                        {{ $t("3_phase") }}: {{ getSocketData.Data.V3 }} V /
                        {{
                          (
                            (getSocketData.Data.P3 * 1000) /
                            getSocketData.Data.V3
                          ).toFixed(2)
                        }}
                        A
                      </span>
                    </div>
                  </div>
                </div>
                <button class="finish_charge" v-bind:class="{disabled: isBlockStopCharge(this.getAccountInfo.Sessions._duration)}" :disabled="isBlockStopCharge(this.getAccountInfo.Sessions._duration)" @click="stopCharge()">
                  {{ $t("finish_charge") }}
                </button>
              </div>
              <div v-if="!sessionIsMoreThanTwoMinutes(getSocketData.Data)" class="tariff">
                <strong>{{ $t("plugshare_time") }}</strong>
              </div>
              <div v-else-if="getSessionModalData.Price" class="tariff">
                <strong>{{ getSessionModalData.Price }} BGN {{ $t("za") }} 1 kWh</strong>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <BottomMenu v-show="
        !getRfidPage && !getProfilePage && !getHistoryPage && !getBalancePage && !getIsMobile
      " />
      <div v-if="chargeStatus && getIsMobile" class="charge_link_new" @click="setActiveSessionModal" title="Active charge">
          <!-- eslint-disable -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" height="21">
              <g id="Electric_Plug-2" data-name="Electric Plug">
                <path fill="#62A321"
                      d="M44.85,27.47A1,1,0,0,0,44,27H33V12a1,1,0,0,0-1.89-.45l-12,24A1,1,0,0,0,20,37H31V52a1,1,0,0,0,.77.97A.908.908,0,0,0,32,53a1,1,0,0,0,.89-.55l12-24A1.007,1.007,0,0,0,44.85,27.47ZM33,47.76V36a1,1,0,0,0-1-1H21.62L31,16.24V28a1,1,0,0,0,1,1H42.38Z"/>
                <path class="rotatatata" fill="#62A321"
                      d="M56.41,14.58a4.988,4.988,0,0,0-.37-6.62L53.21,5.13a1.024,1.024,0,0,0-1.41,0l-.71.71L48.26,3.01,46.85,4.42l2.83,2.83L48.26,8.67,45.43,5.84,44.02,7.25l2.83,2.83-.71.71a1,1,0,0,0,0,1.41l2.83,2.83a4.936,4.936,0,0,0,5.9.84A27.678,27.678,0,0,1,60,32,28.025,28.025,0,0,1,21.38,57.92l-.76,1.85A30.025,30.025,0,0,0,62,32,29.669,29.669,0,0,0,56.41,14.58Zm-1.78-.96a3.03,3.03,0,0,1-4.25,0l-2.12-2.13,4.25-4.24,2.12,2.12A3.012,3.012,0,0,1,54.63,13.62Z"/>
                <path class="rotatatata" fill="#62A321"
                      d="M32,2A30.037,30.037,0,0,0,2,32,29.669,29.669,0,0,0,7.59,49.42a4.988,4.988,0,0,0,.37,6.62l2.83,2.83a.967.967,0,0,0,.7.29.99.99,0,0,0,.71-.29l.71-.71,2.83,2.83,1.41-1.41-2.83-2.83,1.42-1.42,2.83,2.83,1.41-1.41-2.83-2.83.71-.71a1,1,0,0,0,0-1.41l-2.83-2.83a4.987,4.987,0,0,0-5.9-.84A27.678,27.678,0,0,1,4,32,28.031,28.031,0,0,1,32,4,27.733,27.733,0,0,1,42.62,6.09l.76-1.86A29.93,29.93,0,0,0,32,2ZM9.37,50.38a3.03,3.03,0,0,1,4.25,0l2.12,2.13-4.25,4.24L9.37,54.63A3.012,3.012,0,0,1,9.37,50.38Z"/>
              </g>
            </svg>
          <!-- eslint-enable -->
      </div>
      <div class="toggled_btns" v-if="getIsMobile">
        <div class="info_btn" @click="infoModal = !infoModal">
          <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48px" height="48px">
            <path
              d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 7 L 11 9 L 13 9 L 13 7 L 11 7 z M 11 11 L 11 17 L 13 17 L 13 11 L 11 11 z" />
          </svg>
        </div>
        <div class="reload_btn" v-if="getIsMobile" onclick="window.location.reload()">
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px" y="0px" viewBox="0 0 512 512" style="enable-background: new 0 0 512 512" xml:space="preserve">
      <g>
        <g>
          <g>
            <path
              d="M426.574,403.384c-0.04-0.445-0.11-0.88-0.177-1.317c-0.039-0.253-0.068-0.506-0.115-0.757
        c-0.081-0.425-0.188-0.84-0.294-1.256c-0.066-0.261-0.125-0.524-0.201-0.783c-0.115-0.388-0.252-0.766-0.388-1.145
        c-0.101-0.282-0.195-0.565-0.309-0.843c-0.14-0.344-0.3-0.677-0.458-1.012c-0.141-0.301-0.277-0.603-0.433-0.899
        c-0.161-0.305-0.341-0.598-0.517-0.894c-0.181-0.306-0.357-0.615-0.555-0.914c-0.189-0.285-0.396-0.554-0.598-0.829
        c-0.212-0.289-0.416-0.581-0.644-0.862c-0.229-0.282-0.479-0.545-0.722-0.815c-0.203-0.225-0.388-0.46-0.602-0.679
        c-0.03-0.03-0.063-0.055-0.092-0.085c-0.216-0.218-0.451-0.415-0.677-0.623c-4.089-3.782-9.292-5.686-14.51-5.673h-85.276
        c-11.782,0-21.333,9.551-21.333,21.333c0,11.782,9.551,21.333,21.333,21.333h20.393c-26.343,13.774-55.128,21.323-84.4,21.323
        c-106.042,0-192-85.958-192-192c0-29.414,6.613-57.859,19.169-83.716c5.146-10.599,0.727-23.363-9.872-28.509
        c-10.599-5.146-23.363-0.727-28.509,9.872c-15.361,31.634-23.455,66.447-23.455,102.353
        c0,129.606,105.061,234.667,234.667,234.667c45.644,0,89.851-14.62,128.006-40.418v40.429c0,11.782,9.551,21.333,21.333,21.333
        c11.782,0,21.333-9.551,21.333-21.333v-85.333c0-0.405-0.038-0.8-0.061-1.199C426.598,403.884,426.596,403.634,426.574,403.384z" />
            <path d="M256.001,21.325c-45.622,0-89.833,14.627-127.996,40.422V21.333C128.005,9.551,118.454,0,106.672,0
        C94.89,0,85.339,9.551,85.339,21.333v85.06c-0.001,0.047,0,0.094,0,0.141v0.132c0,0.134,0.018,0.264,0.02,0.398
        c0.01,0.549,0.031,1.097,0.083,1.645c0.025,0.261,0.07,0.515,0.104,0.772c0.057,0.428,0.112,0.856,0.195,1.281
        c0.06,0.308,0.14,0.608,0.213,0.912c0.089,0.369,0.174,0.737,0.283,1.101c0.095,0.319,0.209,0.628,0.319,0.94
        c0.12,0.342,0.236,0.683,0.373,1.02c0.128,0.313,0.274,0.616,0.417,0.921c0.15,0.323,0.296,0.646,0.464,0.962
        c0.165,0.312,0.348,0.611,0.528,0.913c0.173,0.292,0.34,0.585,0.529,0.87c0.221,0.334,0.461,0.651,0.7,0.972
        c0.175,0.234,0.339,0.473,0.525,0.702c0.319,0.394,0.662,0.767,1.007,1.137c0.117,0.125,0.218,0.258,0.338,0.381
        c0.017,0.017,0.036,0.032,0.053,0.049c0.461,0.467,0.944,0.91,1.446,1.333c0.039,0.033,0.076,0.072,0.115,0.105
        c3.602,2.992,8.205,4.808,13.232,4.899c0.064,0.001,0.127,0.009,0.191,0.01c0.067,0.001,0.132,0.01,0.199,0.01h85.333
        c11.782,0,21.333-9.551,21.333-21.333c0-11.782-9.551-21.333-21.333-21.333h-20.416c26.355-13.784,55.149-21.342,84.412-21.342
        c106.034,0,192,85.972,192,192c0,29.464-6.617,57.929-19.188,83.795c-5.15,10.597-0.734,23.362,9.863,28.512
        c10.597,5.15,23.362,0.734,28.512-9.863c15.381-31.649,23.479-66.486,23.479-102.445C490.668,126.4,385.6,21.325,256.001,21.325z
        " />
          </g>
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
        </div>
        <div class="dc_btn" @click="DCmodeToggle">
          <span style="color: #ef7f1a; font-weight: 500;" v-if="this.getDCmode">DC</span>
          <div style="font-weight: 500; line-height: 1; font-size: 14px" v-else><span style="color:#61a321">AC</span>/<span style="color: #ef7f1a">DC</span></div>
        </div>
        <div class="near_station" @click="nearStation">
          <svg height="20px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <path
              d="m8.828125 282.484375h45.902344c12.0625 91.066406 83.71875 162.722656 174.785156 174.785156v45.902344c.015625 4.871094 3.960937 8.8125 8.828125 8.828125h35.3125c4.867188-.015625 8.8125-3.957031 8.828125-8.828125v-45.902344c91.066406-12.0625 162.722656-83.71875 174.785156-174.785156h45.902344c4.871094-.015625 8.8125-3.960937 8.828125-8.828125v-35.3125c-.015625-4.867188-3.957031-8.8125-8.828125-8.828125h-45.902344c-12.0625-91.066406-83.71875-162.722656-174.785156-174.785156v-45.902344c-.015625-4.871094-3.960937-8.8125-8.828125-8.828125h-35.3125c-4.867188.015625-8.8125 3.957031-8.828125 8.828125v45.902344c-91.066406 12.0625-162.722656 83.71875-174.785156 174.785156h-45.902344c-4.871094.015625-8.8125 3.960937-8.828125 8.828125v35.3125c.015625 4.867188 3.957031 8.8125 8.828125 8.828125zm247.171875-176.554687c82.878906 0 150.070312 67.191406 150.070312 150.070312s-67.191406 150.070312-150.070312 150.070312-150.070312-67.191406-150.070312-150.070312c.117187-82.832031 67.238281-149.953125 150.070312-150.070312zm0 0" />
            <path
              d="m326.621094 256c0 39.003906-31.617188 70.621094-70.621094 70.621094s-70.621094-31.617188-70.621094-70.621094 31.617188-70.621094 70.621094-70.621094 70.621094 31.617188 70.621094 70.621094zm0 0" />
          </svg>
        </div>
      </div>
    </div>
  </div>
  <!-- eslint-enable no-mixed-spaces-and-tabs -->
</template>

<script>
import { LCircle, LIcon, LMap, LMarker, LTileLayer } from "vue2-leaflet";
import { mapGetters } from "vuex";
import axios from "axios";
import ListPage from "./ListPage";
import FavoritesPage from "./FavoritesPage";
import BottomMenu from "./BottomMenu";
import Vue from "vue";
import { Flip } from "number-flip";

export default {
  name: "MapPage",
  components: {
    LMap,
    LTileLayer,
    LIcon,
    LMarker,
    LCircle,
    ListPage,
    FavoritesPage,
    BottomMenu,
  },
  data() {
    return {
      toggledBtns: false,
      flipInstance: null,
      valueFromVuex: 0,
      animatedNumber: null,
      techDataDC: true,
      techDataAC: false,
      checkedDc: null,
      prepareChargeData: null,
      realtime: false,
      geoStatus: false,
      infoModal: false,
      modalStatus: 1,
      activeStationPopup: false,
      confirmationCharge: null,
      pseudo_activated_charge: false,
      coverageAreaCircleRadius: 100000,
      coverageAreaRadiusShowed: false,
      activeChargeData: null,
      coverageArea: false,
      disableMarker: false,
      activeSpinner: true,
      locationModal: false,
      zoom: 3,
      center: [47.75, 25.14],
      iconSize: 20,
      iconShadow: "/images/marker-shadow.png",
      url: "https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoidm9sdHNwb3QiLCJhIjoiY2x6aWM1dHZ0MGYzdTJpcjE2cGVkNnJyYyJ9.JwyhwF5Qsdup3iXJenv2Tw",
      // url: "https://api.maptiler.com/maps/streets-v2/{z}/{x}/{y}@2x.png?key=JBvMi0gSpBxp6VpCeUIb",
      // url: "https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}{r}.png",
      // url: "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
      // url: "https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}{r}.png",
      attribution:
        '<a href="https://osm.org/copyright">OpenStreetMap</a> | <a href="https://www.mapbox.com/">Mapbox</a>',
      tile_options: {
        zoomOffset: -1,
        maxZoom: 18,
        tileSize: 512,
      },
      mapOptions: {
        doubleClickZoom: true,
        scrollWheelZoom: true,
      },
      clusterOptions: {
        showCoverageOnHover: true,
        maxClusterRadius: 10.9,
      },
      grayIcon:
        "/images/location_icons/flash-ac-gray.png",
      greenIcon:
        "/images/location_icons/flash-ac-green.png",
      redIcon:
        "/images/location_icons/flash-ac-red.png",
      blueIcon:
        "/images/location_icons/flash-ac-blue.png",
      gbIcon:
        "/images/location_icons/flash-ac-blue-green.png",
      gray1Icon:
        "/images/location_icons/flash-dc-gray.png",
      red1Icon:
        "/images/location_icons/flash-dc-red.png",
      blue1Icon:
        "/images/location_icons/flash-dc-blue.png",
      orange1Icon:
        "/images/location_icons/flash-dc-orange.png",
      ob1Icon:
        "/images/location_icons/flash-dc-blue-orange.png"
    };
  },
  mounted() {
    // setInterval(this.changeAsd, 3000);
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        if(this.modalStatus === 2 && this.confirmation_charge && !this.activeSpinner && !this.activeStationPopup) {
          this.setConfirmationCharge(this.confirmationCharge.id);
        }
      }
    });
    let _this = this;
    this.$refs.osm_map.mapObject.zoomControl.setPosition("bottomright");
    let browser = window.navigator.userAgent.substr(-40);
    let firefox = browser.indexOf("Firefox");
    let mi = browser.indexOf("MiuiBrowser");
    if (firefox >= 0 || mi >= 0) {
      document.querySelector(".top_board").style.background =
        "rgba(255, 255, 255, 0.95)";
      document.querySelector(".bottom_board").style.background =
        "rgba(255, 255, 255, 0.95)";
    }
    // Открыть активную станцию
    this.$on("flyToActiveSpot", function (data) {
      this.activeStationPopup = true;
      if (this.disableMarker === false) {
        this.$store.commit("setSessionModalData", data);
        if (_this.locationModal === true) {
          _this.chargeView = false;
          _this.locationModal = false;
          setTimeout(() => (_this.locationModal = true), 10);
          _this.activeSpinner = true;
          setTimeout(() => (_this.activeSpinner = false), 510);
        } else {
          this.locationModal = true;
          _this.activeSpinner = true;
          setTimeout(() => (_this.activeSpinner = false), 510);
        }

        // let currentZoom = this.$refs.osm_map.mapObject.getZoom();

        _this.$refs.osm_map.mapObject.flyTo([data.Corlat, data.Corlng], 12, {
          animate: true,
          duration: 0.3,
        });
        setTimeout(() => setModalPosition(), 530);
        let setModalPosition = function () {
          let map_height = document.getElementById("map").offsetHeight;
          let map_offset = document.getElementById("map").offsetTop;
          let modal_height = function () {
            if (document.getElementById("location_modal")) {
              return document.getElementById("location_modal").offsetHeight;
            } else {
              return 105;
            }
          };
          let pan_count = map_height / 2 + map_offset - modal_height() - 190;
          _this.$refs.osm_map.mapObject.panBy([0, pan_count], {
            animate: true,
            duration: 0.4,
          });
        };
        this.disableMarker = true;
      }
      setTimeout(() => (this.disableMarker = false), 530);
    });
    // Перемещение карты к станции по клику со страницы "Список" или "Избранные"
    this.$on("flyToSpot", function (data) {
      this.activeStationPopup = false;
      this.confirmationCharge = null;
      let statKey = data.Key;
      let currStatKey;
      if (this.getAuthStatus && this.getAccountInfo.Sessions !== null) {
        currStatKey = this.getAccountInfo.Sessions.LocationId;
      }
      if (
        statKey === currStatKey &&
        this.getSocketData !== null &&
        (this.getSocketData.Event === "started" ||
          this.getSocketData.Event === "tick")
      ) {
        _this.modalStatus = 4;
      } else if (
        statKey === currStatKey &&
        this.getSocketData !== null &&
        this.getSocketData.Event === "activated"
      ) {
        _this.modalStatus = 3;
      } else _this.modalStatus = 1;
      if (this.disableMarker === false) {
        this.$store.commit("setSessionModalData", data);
        if (_this.locationModal === true) {
          _this.chargeView = false;
          _this.locationModal = false;
          setTimeout(() => (_this.locationModal = true), 10);
          _this.activeSpinner = true;
          setTimeout(() => (_this.activeSpinner = false), 510);
        } else {
          this.locationModal = true;
          _this.activeSpinner = true;
          setTimeout(() => (_this.activeSpinner = false), 510);
        }

        // let currentZoom = this.$refs.osm_map.mapObject.getZoom();

        _this.$refs.osm_map.mapObject.flyTo([data.Corlat, data.Corlng], 12, {
          animate: true,
          duration: 0.3,
        });
        setTimeout(() => setModalPosition(), 530);
        let setModalPosition = function () {
          let map_height = document.getElementById("map").offsetHeight;
          let map_offset = document.getElementById("map").offsetTop;
          let modal_height = function () {
            if (document.getElementById("location_modal")) {
              return document.getElementById("location_modal").offsetHeight;
            } else {
              return 105;
            }
          };
          let pan_count = map_height / 2 + map_offset - modal_height() - 190;
          _this.$refs.osm_map.mapObject.panBy([0, pan_count], {
            animate: true,
            duration: 0.4,
          });
        };
        this.disableMarker = true;
      }
      setTimeout(() => (this.disableMarker = false, this.activeSpinner = false), 530);
    });
    this.zoomMap();
  },
  computed: {
    ...mapGetters([
      "getAccountInfo",
      "getSocketData",
      "getSocketFinishedData",
      "getStations",
      "getSessionModalData",
      "getListPage",
      "getLegend",
      "getIsMobile",
      "getGeoFound",
      "getAuthStatus",
      "getFavoritesPage",
      "getReconnectSocket",
      "getProfilePage",
      "getHistoryPage",
      "getBalancePage",
      "getRfidPage",
      "getUserGeoposition",
      "getRealtimeUserPosition",
      "getDCmode",
    ]),
    chargeStatus() {
      if (this.$store.getters.getSocketData !== null && this.$store.getters.getSocketFinishedData === null || typeof this.getAccountInfo.Sessions === 'object' && !Array.isArray(this.getAccountInfo.Sessions) && this.getAccountInfo.Sessions !== null) {
        if (typeof this.getAccountInfo.Sessions === 'object' && !Array.isArray(this.getAccountInfo.Sessions) && this.getAccountInfo.Sessions !== null) {
          return true
        }
        let x = this.$store.getters.getSocketData.Event
        if (x === 'tick' || x === 'started' && x !== 'canceled' && x !== 'finished') {
          return true
        }
      }
      return false
    },
    roundedCircleRadius() {
      return this.coverageAreaCircleRadius / 1000;
    },
    coverageAreaCircleRadiusToNumber() {
      let _this = this;
      return Number(_this.coverageAreaCircleRadius);
    },
    watcherRealtimeUserPosition() {
      return this.$store.getters.getRealtimeUserPosition;
    },
    webShareApiSupported() {
      return navigator.share;
    },
  },
  watch: {
    valueFromVuex(newValue, oldValue) {
      if (!this.flipInstance) {
        this.flipInstance = new Flip({
          node: this.$refs.animatedNumber,
          from: oldValue,
          to: newValue,
          separator: '.',
        });
      } else {
        this.flipInstance.flipTo({
          from: oldValue,
          to: newValue,
        });
      }
    },
    geoStatus: {
      handler() {
        this.zoomMap();
      },
      deep: true,
    },
    watcherRealtimeUserPosition() {
      this.setRealtimeGeoposition();
    },
  },
  methods: {
    setActiveSessionModal() {
      let fromx = this.$store.getters.getAccountInfo.Sessions.LocationId
      let fromy = this.$store.getters.getStations
      let outer = fromy.find(fromy => fromy.Key === fromx)
      this.$emit('flyToActiveSpot', outer)
    },
    getSocketTypeName(socket) {
      if(!socket.Type) return '';

      let word = socket.Type
      if(word === 'ccs') {
        return 'CCS'
      } else {
        return word.charAt(0).toUpperCase() + word.slice(1)
      }
      
      // switch(socket.Type) {
      //   case 'chademo':
      //     return 'Chademo';
      //   case 'type2':
      //     return 'Type2';
      //   default:
      //     return socket.Type.toUpperCase();
      // }
    },
    dirkaStatus(socket) {
      let status = socket?.Status;
      if(status) {
        if(status === "Online") {
          return 'Online'
        }
        if(status === "Busy") {
          return 'Busy'
        }
        if(status === "Error") {
          return 'Error'
        }
        if(status === "Disabled") {
          return 'Disabled'
        }
      }
      return '';
    },
    changeAsd() {
      const min = 1;
      const max = 15;
      const randomNumber = Math.random() * (max - min) + min;
      let roundedNumber = randomNumber.toFixed(2);
      roundedNumber = roundedNumber.toString();
      roundedNumber = roundedNumber.replace('.', '');
      roundedNumber = parseFloat(roundedNumber);
      console.log(roundedNumber)
      this.valueFromVuex = roundedNumber;
    },
    isBlockStopCharge(time) {
      if(!time) return false;
      let parts = time.split(':');
      let hours = parseInt(parts[0]);
      let minutes = parseInt(parts[1]);
      if(hours === 0 && minutes < 1) {
        return true;
      } else {
        return false;
      }
    },
    socketsHasFreePort(){
      let sockets = this.prepareChargeData.Sockets;
      let hasFree = Object.values(sockets).some(socket => socket.Busy === 0);
      return hasFree;
    },
    DCmodeToggle() {
      if(this.getDCmode) {
        this.$store.commit('setDCmode', false)
      } else {
        this.$store.commit('setDCmode', true)
      }
      this.$store.dispatch("gotStations");
    },
    initMapReady() {
      this.$store.commit("setMapReadyStatus", true);
    },
    sessionIsMoreThanTwoMinutes(data) {
      if(!data.Duration) {
        return false;
      }
      if(parseInt(data.Duration) <= 120) {
        return false;
      }
      return true;
    },
    removeSeconds(time) {
      if(!time) return '';
      let parts = time.split(':');
      let hours = parseInt(parts[0]);
      let minutes = parseInt(parts[1]);
      let formattedTime = hours + 'h : ' + minutes + 'm';

      let cookLang = localStorage.getItem("SessionLang");
        if (cookLang === "ru") {
          formattedTime = hours + 'ч : ' + minutes + 'м';
        } else if (cookLang === "en") {
          formattedTime = hours + 'h : ' + minutes + 'm';
        } else if (cookLang === "kz") {
          formattedTime = hours + 'h : ' + minutes + 'm';
        } else {
          formattedTime = hours + 'ч : ' + minutes + 'м';
        }

      return formattedTime;
    },
    open_in_new_tab() {
      if(this.$store.getters.getIsProd === true) {
        window.location.href = 'https://my.voltflot.net/?sid='+localStorage.getItem('AuthToken')+'&lang='+localStorage.getItem('SessionLang');
      } else {
        window.location.href = 'https://my2.voltflot.net/?sid='+localStorage.getItem('AuthToken')+'&lang='+localStorage.getItem('SessionLang');
      }
    },
    getChargeStatus(import_val) {
      let status = this.getAccountInfo.Sessions.Status;
      let cookLang = localStorage.getItem("SessionLang");
      console.log('import_val '+import_val)
      if ((import_val !== null && import_val !== 'undefined') && (parseFloat(import_val) < 0.01)) {
        if (cookLang === "ru") {
          return 'ЗАПУСКАЕТСЯ';
        } else if(cookLang === 'bg') {
          return 'СТАРТИРА';
        } else if(cookLang === 'kz') {
          return 'BASTALADY';
        } else {
          return 'STARTING';
        }
      }

      if (import_val == null || import_val === 'undefined') {
        if (cookLang === "ru") {
          return 'ЗАПУСКАЕТСЯ';
        } else if(cookLang === 'bg') {
          return 'СТАРТИРА';
        } else if(cookLang === 'kz') {
          return 'BASTALADY';
        } else {
          return 'STARTING';
        }
      }

      if (cookLang === "ru") {
        if(status === "STARTED") {
            return "ЗАРЯЖАЕТ"
          } else if(status === "ACTIVATED") {
            return "ЗАПУСКАЕТСЯ"
          } else if(status === "PAUSED") {
            return "НА ПАУЗЕ"
          }
          else return status;
        } else if (cookLang === "bg") {
          if(status === "STARTED") {
            return "ЗАРЕЖДА"
          } else if(status === "ACTIVATED") {
            return "СЕ СТАРТИРА"
          } else if(status === "PAUSED") {
            return "НА ПАУЗА"
          }
          else return status;
        } else if (cookLang === "kz") {
          if(status === "STARTED") {
            return "ZARÄDTAU"
          } else if(status === "ACTIVATED") {
            return "BASTAU"
          } else if(status === "PAUSED") {
            return "ÜZILISTE"
          }
          else return status;
        } else if (cookLang === 'en') {
          if(status === "STARTED") {
            return "CHARGING NOW"
          } else if(status === "PAUSED") {
            return "PAUSE"
          }
          else return status;
        }
        else {
          return status;
        }
    },
    share_station(data) {
      let url = "https://my.voltspot.net/?lid=" + data.Key;
      const shareData = {
        text: data.Title + " " + "charger",
        url: url,
      };

      navigator.share(shareData);
    },
    setRealtimeGeoposition() {
      this.realtime = this.getRealtimeUserPosition;
    },
    installPWA() {
      this.installEvent.prompt();
      this.installEvent.userChoice.then((choice) => {
        this.shown = false;
        if (choice.outcome === "accepted") {
          // Do something additional if the user chose to install
        } else {
          // Do something additional if the user declined
        }
      });
    },
    detach_check() {
      return (
        this.getSocketData == null &&
        typeof this.getAccountInfo.Sessions === "object" &&
        !Array.isArray(this.getAccountInfo.Sessions) &&
        this.getAccountInfo.Sessions !== null
      );
    },
    setBalancePage() {
      this.$store.commit("setBalancePage");
    },
    zoomToUser() {
      let latlng = this.getUserGeoposition;
      this.$refs.osm_map.mapObject.flyTo([latlng.lat, latlng.lng], 12, {
        animate: true,
        duration: 1,
      });
      // _this.$refs.osm_map.mapObject.setView([latlng.lat, latlng.lng], 10)
    },
    zoomToCountry() {
      let countryUrl =
        process.env.VUE_APP_API_URL + "/app/besp/location/country/?format=json";
      axios({
        url: "https://voltspot.net/url/cors.php",
        method: "POST",
        params: {
          url: countryUrl,
        },
      }).then((resp) => {
        if (resp.data.rcode >= 0) {
          let lat = resp.data.rdata.Records[1].Corlat;
          let lng = resp.data.rdata.Records[1].Corlng;
          this.$refs.osm_map.mapObject.flyTo([lat, lng], 8, {
            animate: true,
            duration: 1,
          });
          // _this.$refs.osm_map.mapObject.setView([lat, lng], 10)
        } else {
          console.log("Ошибка получения координат страны: " + resp.data.rtext);
        }
      });
    },
    zoomMap() {
      let _this = this;
      this.$refs.osm_map.mapObject.zoomControl.setPosition("bottomright");
      // Зум карты по позиции пользователя
      let params = new URL(document.location).searchParams;
      if (params.get("lid")) {
        let stationsUrl = "";
        if (_this.$store.getters.getIsProd) {
          if (localStorage.getItem("AuthToken") === null) {
            stationsUrl =
              process.env.VUE_APP_API_URL + "/app/besp/location/records/?format=json" +
              "&lang=" +
              localStorage.getItem('SessionLang');
          } else {
            stationsUrl =
              process.env.VUE_APP_API_URL + "/app/besp/location/records/?f_token=" +
              localStorage.getItem("AuthToken") +
              "&format=json" +
              "&lang=" +
              localStorage.getItem('SessionLang');
          }
        } else {
          if (localStorage.getItem("AuthToken") === null) {
            stationsUrl =
              process.env.VUE_APP_API_URL + "/app/besp/location/records/?format=json" +
              "&lang=" +
              localStorage.getItem('SessionLang');
          } else {
            stationsUrl =
              process.env.VUE_APP_API_URL + "/app/besp/location/records/?f_token=" +
              localStorage.getItem("AuthToken") +
              "&format=json" +
              "&lang=" +
              localStorage.getItem('SessionLang');
          }
        }
        axios({
          url: "https://voltspot.net/url/cors.php",
          method: "POST",
          params: {
            url: stationsUrl,
          },
        }).then((resp) => {
          if (resp.data.rcode > 0) {
            let location_id = params.get("lid");
            let stations = resp.data.rdata.Records;
            let location = stations.find((o) => o.Key == location_id);
            this.$store.commit("setSessionModalData", location);
            //this.activeStationPopup = true
            if (this.disableMarker === false) {
              if (this.locationModal === true) {
                this.locationModal = false;
                setTimeout(() => (_this.locationModal = true), 10);
                this.activeSpinner = true;
                setTimeout(() => (_this.activeSpinner = false), 510);
              } else {
                this.locationModal = true;
                this.activeSpinner = true;
                setTimeout(() => (_this.activeSpinner = false), 510);
              }

              // let currentZoom = this.$refs.osm_map.mapObject.getZoom();

              _this.$refs.osm_map.mapObject.flyTo(
                [location.Corlat, location.Corlng],
                12,
                {
                  animate: true,
                  duration: 0.3,
                }
              );
              setTimeout(() => setModalPosition(), 530);
              let setModalPosition = function () {
                let map_height = document.getElementById("map").offsetHeight;
                let map_offset = document.getElementById("map").offsetTop;
                let modal_height = function () {
                  if (document.getElementById("location_modal")) {
                    return document.getElementById("location_modal")
                      .offsetHeight;
                  } else {
                    return 105;
                  }
                };
                let pan_count =
                  map_height / 2 + map_offset - modal_height() - 190;
                _this.$refs.osm_map.mapObject.panBy([0, pan_count], {
                  animate: true,
                  duration: 0.4,
                });
              };
              this.disableMarker = true;
            }
            setTimeout(() => (this.disableMarker = false), 530);
          } else {
            console.log("Ошибка получения списка станций: " + resp.data.rtext);
          }
        });
      } else {
        _this.$nextTick(() => {
          const check_geo_interval = setInterval(check_geo_func, 500);

          function check_geo_func() {
            _this.geoStatus = _this.getUserGeoposition;
            if (_this.geoStatus) {
              _this.zoomToUser();
              clearInterval(check_geo_interval);
            }
          }

          setTimeout(() => {
            clearInterval(check_geo_interval);
            if (!_this.geoStatus) {
              _this.zoomToCountry();
            }
          }, 10000);
        });
      }
    },
    default_charge() {
      if (
        this.$store.getters.getSocketFinishedData === null &&
        this.confirmationCharge === null &&
        this.activeSpinner === false
      ) {
        return true;
      }
    },
    setConfirmationCharge(station, red = null) {
      if(red && red === 'red') {
        return false
      }
      let _this = this;
      this.checkedDc = null;
      if (this.$store.getters.getAuthStatus === true) {
        if (station.StatusId === 3 && this.$store.getters.getSocketData === null || station.StatusId === 4 && this.$store.getters.getSocketData === null || station.Type === 'dc' && station.StatusId === 2 && this.$store.getters.getSocketData === null) {
          this.activeSpinner = true;
          this.pseudo_activated_charge = true;
          this.modalStatus = 3;
          let startSessionUrl =
            process.env.VUE_APP_API_URL + "/app/besp/session/prepare/?f_token=" +
            localStorage.getItem("AuthToken") +
            "&f_station_id=" +
            station.id +
            "&format=json";
          axios({
            url: "https://voltspot.net/url/cors.php",
            method: "POST",
            params: {
              url: startSessionUrl,
            },
          })
            .then((resp) => {
              console.log(resp.data)
              _this.activeSpinner = false;
              _this.confirmationCharge = station;
              _this.modalStatus = 2;
              if (resp.data.rcode > 0) {
                _this.prepareChargeData = resp.data.rdata;
                if(Object.keys(_this.prepareChargeData.Sockets).length == 1) {
                  _this.checkedDc = 1;
                }
              } else {
                console.log("Ошибка подготовки зарядки");
              }
            })
            .catch((err) => {
              console.log("Ошибка: " + err);
            });
        }
      } else {
        this.$store.state.AuthModal = true;
      }
    },
    confirmation_charge() {
      return this.confirmationCharge !== null;
    },
    setActivatedCharge() {
      if(!this.socketsHasFreePort) {
        return false;
      }
      let get_msg_charge_canceled = function () {
        let cookLang = localStorage.getItem("SessionLang");
        if (cookLang === "ru") {
          return "Зарядка отменена";
        } else if (cookLang === "en") {
          return "Charging is canceled";
        } else if (cookLang === "kz") {
          return "Zarädtau toqtatyldy";
        } else {
          return "Зареждането е отменено";
        }
      };
      let _this = this;
      this.pseudo_activated_charge = true;
      this.modalStatus = 3;
      let startSessionUrl = '';

      if(_this.prepareChargeData.Type == 'dc' && _this.checkedDc) {
        startSessionUrl =
        process.env.VUE_APP_API_URL + "/app/besp/session/activate/?f_token=" +
        localStorage.getItem("AuthToken") +
        "&f_station_id=" +
        this.confirmationCharge.id +
        "&f_socket_id=" +
        _this.checkedDc +
        "&format=json";
      } else {
        startSessionUrl =
        process.env.VUE_APP_API_URL + "/app/besp/session/activate/?f_token=" +
        localStorage.getItem("AuthToken") +
        "&f_station_id=" +
        this.confirmationCharge.id +
        "&format=json";
      }

      axios({
        url: "https://voltspot.net/url/cors.php",
        method: "POST",
        params: {
          url: startSessionUrl,
        },
      })
        .then((resp) => {
          this.confirmationCharge = null;
          this.checkedDc = null;
          if (resp.data.rcode > 0) {
            this.$store.dispatch("gotAccountInfo");
            let id = setInterval(function () {
              if (_this.$store.getters.getSocketData !== null) {
                if (
                  _this.$store.getters.getSocketData.Event === "started" ||
                  _this.$store.getters.getSocketData.Event === "tick"
                ) {
                  _this.modalStatus = 4;
                  clearInterval(id);
                } else if (
                  _this.$store.getters.getSocketData.Event === "canceled"
                ) {
                  _this.locationModal = false;
                  _this.modalStatus = 1;
                  clearInterval(id);
                  Vue.notify({
                    type: "warn",
                    text: get_msg_charge_canceled(),
                  });
                }
              }
            }, 3000);
          } else {
            console.log("Ошибка старта зарядки");
          }
        })
        .catch((err) => {
          console.log("Ошибка старта зарядки: " + err);
        });
    },
    activated_charge() {
      let _this = this;
      if (this.$store.getters.getSocketData !== null) {
        if (this.$store.getters.getSocketData.Event === "activated") {
          _this.pseudo_activated_charge = false;
          return true;
        }
        return false;
      }
      return false;
    },
    started_charge() {
      let _this = this;
      let x = this.getAccountInfo;
      if (this.$store.getters.getSocketData !== null) {
        if (
          this.$store.getters.getSocketData.Event === "started" ||
          this.$store.getters.getSocketData.Event === "tick"
        ) {
          _this.activeChargeData = x;
          return true;
        }
        return false;
      }
      return false;
    },
    stopCharge() {
      // let xx = "Спиране на зареждането?";
      // let langg = localStorage.getItem("SessionLang");
      // if (langg == "ru") {
      //   xx = "Остановить зарядку?";
      // } else if (langg == "en") {
      //   xx = "Stop the charging?";
      // } else if (langg == "kz") {
      //   xx = "Zarädtaudy toqtatu?";
      // }

      // let stop_charge_confirm = confirm(xx);
      // if (!stop_charge_confirm) {
      //   return false;
      // }

      this.activeSpinner = true;
      let _this = this;
      let sessid = this.$store.getters.getAccountInfo.Sessions.Sessid;
      let endSessionUrl =
        process.env.VUE_APP_API_URL + "/app/besp/session/stop/?f_token=" +
        localStorage.getItem("AuthToken") +
        "&format=json" +
        "&f_sessid=" +
        sessid;
      axios({
        url: "https://voltspot.net/url/cors.php",
        method: "POST",
        params: {
          url: endSessionUrl,
        },
      })
        .then((resp) => {
          if (resp.data.rcode > 0) {
            console.log("Зарядка закончена");
            _this.$store.dispatch("gotAccountInfo");
          } else {
            console.log("Ошибка окончания зарядки");
          }
        })
        .catch((err) => {
          console.log("Ошибка окончания зарядки: " + err);
        });
    },
    finished_charge() {
      let _this = this;
      if (this.getSocketFinishedData !== null || this.modalStatus === 5) {
        _this.activeSpinner = false;
        _this.modalStatus = 5;
        return true;
      }
      return false;
    },
    stationStatus(StatusId, stationType) {
      if(stationType === 'ac') {
        return StatusId === 3 && this.$store.getters.getSocketData === null || StatusId === 4 && this.$store.getters.getSocketData === null;
      } else {
        return StatusId === 2 && this.$store.getters.getSocketData === null || StatusId === 3 && this.$store.getters.getSocketData === null || StatusId === 4 && this.$store.getters.getSocketData === null;
      }
    },
    colorStatus(StatusId, red = null) {
      if(red && red === 'red') {
        return 'red';
      }
      switch (StatusId) {
        case 1:
          return "red";
        case 2:
          return "blue";
        case 3:
          return "green";
        case 4:
          return "green";
      }
    },
    parseStations(stations) {
      let data = JSON.parse(stations);
      if(Object.keys(data).length === 0) return false;
      data = data.sort((a, b) => {
        return b['Type'].localeCompare(a['Type']);
      });
      return data;
    },
    switchIcon(BespsLocationType, BespbLocationStatus) {
      let _this = this;
      if (BespsLocationType === "ac") {
        switch (BespbLocationStatus) {
          case "green":
            return _this.greenIcon;
          case "gray":
            return _this.grayIcon;
          case "red":
            return _this.redIcon;
          case "gb":
            return _this.gbIcon;
          case "blue":
            return _this.blueIcon;
        }
      } else if (BespsLocationType === "dc") {
        switch (BespbLocationStatus) {
          case "green":
            return _this.orange1Icon;
          case "gray":
            return _this.gray1Icon;
          case "red":
            return _this.red1Icon;
          case "ob":
            return _this.ob1Icon;
          case "blue":
            return _this.blue1Icon;
        }
      }
    },
    triggerStationModal(item) {
      this.activeStationPopup = false;
      this.confirmationCharge = null;
      let _this = this;
      let statKey = item.Key;
      let currStatKey;
      if (this.getAuthStatus && this.getAccountInfo.Sessions !== null) {
        currStatKey = this.getAccountInfo.Sessions.LocationId;
      }

      if (
        statKey === currStatKey &&
        this.getSocketData !== null &&
        (this.getSocketData.Event === "started" ||
          this.getSocketData.Event === "tick")
      ) {
        _this.modalStatus = 4;
      } else if (
        statKey === currStatKey &&
        this.getSocketData !== null &&
        this.getSocketData.Event === "activated"
      ) {
        _this.modalStatus = 3;
      } else if (statKey === currStatKey && this.getSocketData === null) {
        _this.modalStatus = 1;
      } else _this.modalStatus = 1;
      if (this.disableMarker === false) {
        _this.$store.commit("setSessionModalData", item);
        if (_this.$store.getters.getSocketFinishedData !== null) {
          _this.$store.commit("clearSocketData");
        }
        if (_this.locationModal === true) {
          _this.locationModal = false;
          setTimeout(() => (_this.locationModal = true), 10);
          _this.activeSpinner = true;
          setTimeout(() => (_this.activeSpinner = false), 510);

        } else {
          _this.locationModal = true;
          _this.activeSpinner = true;
          setTimeout(() => (_this.activeSpinner = false), 510);
        }

        _this.$refs.osm_map.mapObject.panTo([item.Corlat, item.Corlng], {
          animate: true,
          duration: 0.4,
        });

        setTimeout(() => setModalPosition(), 530);
        let setModalPosition = function () {
          let map_height = document.getElementById("map").offsetHeight;
          let map_offset = document.getElementById("map").offsetTop;
          let modal_height = function () {
            if (document.getElementById("location_modal")) {
              return document.getElementById("location_modal").offsetHeight;
            }
            return 105;
          };
          let pan_count = map_height / 2 + map_offset - modal_height() - 150;
          _this.$refs.osm_map.mapObject.panBy([0, pan_count], {
            animate: true,
            duration: 0.45,
          });
        };
        _this.disableMarker = true;
      }
      setTimeout(() => (_this.disableMarker = false), 530);
    },
    toggleFavorite(Bookmark, Key) {
      let _this = this;
      if (this.$store.getters.getAuthStatus === true) {
        if (Bookmark <= 0) {
          _this.$store.dispatch("setFavoriteSpot", Key).then(() => {
            _this.$store.dispatch("gotStations");
          });
        } else {
          _this.$store.dispatch("removeFavoriteSpot", Key).then(() => {
            _this.$store.dispatch("gotStations");
          });
        }
      } else {
        this.$store.state.AuthModal = true;
      }
    },
    goRoute: function (lat, lng, map) {
      if (map === "google") {
        window.open(
          "https://maps.google.com?daddr=" + lat + "," + lng + "",
          "_blank"
        );
      } else if (map === "apple") {
        window.open(
          "https://maps.apple.com/?daddr=" + lat + "," + lng + "",
          "_blank"
        );
      } else if (map === "waze") {
        window.open(
          "https://ul.waze.com/ul?ll=" + lat + "%2C" + lng + "&navigate=yes",
          "_blank"
        );
      } else {
        window.open(
          "https://maps.google.com?daddr=" + lat + "," + lng + "",
          "_blank"
        );
      }
    },
    stationCurrentPower(id) {
      let openedStation = this.$store.getters.getSessionModalData.Key;
      let stations = this.$store.getters.getStations;
      let station = stations.find((item) => item.Key === openedStation);
      let aaa = JSON.parse(station.StationsObj);
      let res = aaa.find((item) => item.id === id);
      return res.Power;
    },
    checkLang() {
      return localStorage.getItem("SessionLang");
    },
    getPrepareDetails(details) {
      if(!details) {
        return ''
      }
      console.log(details)
      let status = ''

      if(details.Activated == 0 && details.Status === 'Online' && details.Details === '') {
        status = 'Free'
      } else if(details.Activated === 0 && details.Status === 'Online' && details.Details === 'Prepairing') {
        status = 'Ready'
      } else if(details.Activated === 0 && details.Status === 'Warning' && details.Details === 'Declined') {
        status = 'Ready'
      } else if(details.Activated === 0 && details.Status === 'Busy' && details.Details === 'Preparing' && details.Busy == 0) {
        status = 'Ready'
      } else if(details.Activated === 1 && details.Status === 'Online' && details.Details === '') {
        status = 'Starting'
      } else if(details.Activated === 1 && details.Status === 'Busy' && details.Details === 'Prepairing') {
        status = 'Preparing'
      } else if(details.Activated === 1 && details.Status === 'Busy' && details.Details === 'Finished') {
        status = 'Finished'
      } else if(details.Status === 'Busy' && details.Details === 'Unavailable') {
        status = 'Unavailable'
      } else if(details.Status === 'Busy' && details.Details === 'Cooldown') {
        status = 'Cooldown'
      } else if(details.Activated === 1 && details.Status === 'Busy' && details.Details === 'Charging') {
        status = 'Charging'
      } else if(details.Status === 'Busy' && details.Details === 'Expired') {
        status = 'Expired'
      }

      let cookLang = localStorage.getItem("SessionLang");
      switch (status) {
        case 'Cooldown':
          if(cookLang === 'kz') {
            return 'Bosatylğan'
          } else if(cookLang === 'en') {
            return 'Cooling down'
          } else if(cookLang === 'bg') {
            return 'Се освобождава'
          } else {
            return 'Освобождается'
          }
        case 'Declined':
          if(cookLang === 'kz') {
            return 'Daiyndyq'
          } else if(cookLang === 'en') {
            return 'Preparing'
          } else if(cookLang === 'bg') {
            return 'Подготовяне'
          } else {
            return 'Подготовка'
          }
        case 'Preparing':
          if(cookLang === 'kz') {
            return 'Daiyndyq'
          } else if(cookLang === 'en') {
            return 'Preparing'
          } else if(cookLang === 'bg') {
            return 'Подготовяне'
          } else {
            return 'Подготовка'
          }
        case 'Starting':
          if(cookLang === 'kz') {
            return 'Iske qosylady'
          } else if(cookLang === 'en') {
            return 'Starting'
          } else if(cookLang === 'bg') {
            return 'Стартира'
          } else {
            return 'Запускается'
          }
        case 'Finished':
          if(cookLang === 'kz') {
            return 'EV zarädtalğan'
          } else if(cookLang === 'en') {
            return 'Finished'
          } else if(cookLang === 'bg') {
            return 'Зареден ЕА'
          } else {
            return 'Заряжен EV'
          }
        case 'Unavailable':
          if(cookLang === 'kz') {
            return 'Qol jetımdı emes'
          } else if(cookLang === 'en') {
            return 'Unavailable'
          } else if(cookLang === 'bg') {
            return 'Недостъпен'
          } else {
            return 'Недоступен'
          }
          case 'Free':
          if(cookLang === 'kz') {
            return 'Tegın'
          } else if(cookLang === 'en') {
            return 'Free'
          } else if(cookLang === 'bg') {
            return 'Свободен'
          } else {
            return 'Свободен'
          }
          case 'Charging':
          if(cookLang === 'kz') {
            return 'Zarädtalady'
          } else if(cookLang === 'en') {
            return 'Charging'
          } else if(cookLang === 'bg') {
            return 'Се зарежда'
          } else {
            return 'Заряжается'
          }
        default:
          return status;
      }
    },
    getAvailablePower(price) {
      if (price == 0 || price === "0.00") {
        return "∞";
      }

      let balance = this.getAccountInfo.Balance;
      if (price === "" || price == null) {
        return Math.floor(balance / 0.85);
      } else {
        return Math.floor(balance / Number(price).toFixed(2));
      }
    },
    nearStation() {
      let _this = this;
      if (_this.$store.getters.getUserGeoposition !== null) {
        _this.locationModal = false;
        let spots = this.$store.getters.getStations;
        let nearSpot = spots.reduce((a, b) =>
          Number(a.Distance) < Number(b.Distance) ? a : b
        );
        let dataLat = nearSpot.Corlat;
        let dataLng = nearSpot.Corlng;
        _this.$refs.osm_map.mapObject.flyTo([dataLat, dataLng], 14, {
          animate: true,
          duration: 0.3,
        });
      } else {
        let cookLang = localStorage.getItem("SessionLang");
        if (cookLang === "ru") {
          alert("Ваше местоположение не определено!");
        } else if (cookLang === "en") {
          alert("Your location has not been determined!");
        } else if (cookLang === "kz") {
          alert("Sızdıñ ornalasqan jerıñız anyqtalmady!");
        } else {
          alert("Вашето местоположение не е определено!");
        }
      }
    },
    nfcStatus() {
      if (
        this.$store.getters.getSocketData !== null &&
        this.$store.getters.getSocketData.Event === "tick"
      ) {
        let x = this.$store.getters.getSocketData.Data.Nfc;
        if (x == 1) {
          return "active";
        } else if (x == 2) {
          return "waiting";
        }
        return "disable";
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>

.toggled_btns {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  height: 70px;
  display: flex;
  grid-gap: 20px;
  align-items: center;
  justify-content: center;
  z-index: 400;
}

.charge_link_new {
  position: absolute; 
  bottom: 80px; 
  right: calc(50% - 30px); 
  padding: 20px;
  background-color: #fff;
  border-radius: 50%;
  z-index: 400;
  box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.28);
        svg {
          display: flex;
          overflow: visible;
          transform: scale(1.3);
          width: 50px;
          height: 50px;

          .rotatatata {
            animation-name: rotation;
            animation-duration: 3s;
            animation-iteration-count: infinite;
            animation-timing-function: linear;
            transform-origin: center;
          }

          @keyframes rotation {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(-360deg);
            }
          }
        }
      }
.asd {
  position: absolute;
  top: 200px;
  right: 200px;
  z-index: 123123;
  padding: 20px;
  background-color: #000;
  color: #fff;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-slow-enter-active {
  transition: opacity 1s;
}

.fade-slow-leave-active {
  transition: 0.2s;
}

.fade-slow-enter,
.fade-slow-leave-to {
  opacity: 0;
}

.slide-enter-active {
  transition-duration: 0.2s;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  transition-duration: 0.2s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 200px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

.slide-right-enter-active {
  transition-duration: 0.1s;
}

.slide-right-leave-active {
  transition-duration: 0.1s;
}

.slide-right-enter-to,
.slide-right-leave {
  transform: translateX(0);
  overflow: hidden;
}

.slide-right-enter,
.slide-right-leave-to {
  overflow: hidden;
  transform: translateX(100%);
}

.map {
  .leaflet-pane img {
    opacity: 1 !important;
  }

  .map_inner {
    position: relative;
    max-height: 100vh;
    //height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    overflow: hidden;

    .info_modal {
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1000;
      backdrop-filter: blur(1px);
      display: flex;
      justify-content: center;
      align-items: center;

      .info_modal_inner {
        display: flex;
        background: #fff;
        box-shadow: 0 1px 6px 0 rgb(32 33 36 / 30%) !important;
        padding: 40px 20px 20px 20px;
        border-radius: 5px;
        position: relative;
        max-width: 300px;
        width: 100%;

        a {
          position: absolute;
          top: 10px;
          right: 10px;
          line-height: 1;
          cursor: pointer;

          svg {
            path {
              fill: #000;
            }
          }
        }

        .info {
          display: flex;
          flex-direction: column;

          .item {
            display: flex;
            align-items: center;
            margin-bottom: 7px;

            &:last-child {
              margin-bottom: 0;
            }

            .text {
              margin-left: 10px;
            }
          }
        }
      }
    }

    .tech_data {
      padding: 5px;
      line-height: 1.1;
    }

    .tech_title {
      color: #62a321;
      padding: 5px;
      font-size: 13px;
      text-align: center;
      line-height: 1;
      background: #e9e9e9;
    }

    .gear_img {
      height: 86%;
      position: absolute;
      right: 10%;
      top: 7%;
      opacity: 0.25;
      animation: spinner 10s linear infinite;
    }

    @keyframes spinner {
      to {
        transform: rotate(360deg);
      }
    }

    .reload_btn {
      top: 100px;
      right: 10px;
      backdrop-filter: blur(5px);
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(255, 255, 255, 0.7);
      z-index: 401;
      cursor: pointer;
      position: absolute;
      width: 50px;
      height: 50px;
      box-shadow: 0 1px 6px 0 rgb(32 33 36 / 30%) !important;
      border-radius: 5px;

      svg {
        width: 25px;
      }
    }

    .flot_desktop_btn {
      top: 55px;
      right: 10px;
      backdrop-filter: blur(5px);
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(255, 255, 255, 0.7);
      z-index: 401;
      cursor: pointer;
      position: absolute;
      width: 50px;
      height: 50px;
      box-shadow: 0 1px 6px 0 rgb(32 33 36 / 30%) !important;
      border-radius: 5px;

      img {
        max-width: 40px;
      }
    }

    .info_btn {
      bottom: 80px;
      right: 10px;
      backdrop-filter: blur(5px);
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(255, 255, 255, 0.7);
      z-index: 401;
      cursor: pointer;
      position: absolute;
      width: 50px;
      height: 50px;
      box-shadow: 0 1px 6px 0 rgb(32 33 36 / 30%) !important;
      border-radius: 5px;

      svg {
        width: 25px;
      }
    }

    .dc_btn {
      bottom: 140px;
      right: 10px;
      backdrop-filter: blur(5px);
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(255, 255, 255, 0.7);
      z-index: 401;
      cursor: pointer;
      position: absolute;
      width: 50px;
      height: 50px;
      box-shadow: 0 1px 6px 0 rgb(32 33 36 / 30%) !important;
      border-radius: 5px;
    }

    .pwa_btn {
      bottom: 150px;
      right: 10px;
      backdrop-filter: blur(5px);
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(255, 255, 255, 0.7);
      z-index: 401;
      cursor: pointer;
      position: absolute;
      width: 50px;
      height: 50px;
      box-shadow: 0 1px 6px 0 rgb(32 33 36 / 30%) !important;
      border-radius: 5px;

      svg {
        width: 25px;
      }
    }

    .coverage_area {
      top: 120px;
      left: 10px;
      position: absolute;
      z-index: 401;
      display: flex;
      flex-direction: column;
      box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.28);

      .icon {
        cursor: pointer;
        backdrop-filter: blur(5px);
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(255, 255, 255, 0.7);
        border-radius: 2px 2px 0 0;

        &.active {
          svg {
            fill: #61a321;
          }
        }
      }

      .circle_radius {
        margin-bottom: 0;
        border-top: 1px solid #ccc;
        border-radius: 0 0 2px 2px;
        cursor: pointer;
        backdrop-filter: blur(5px);
        width: 30px;
        height: 100%;
        min-height: 20px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        background-color: rgba(255, 255, 255, 0.7);

        .toggled_block {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;

          .rounded_radius {
            display: flex;
            justify-content: space-between;
            align-items: center;

            input {
              text-align: center;
              outline: none;
              background: transparent;
              border: none;
              cursor: default;
              font-size: 0.8rem;
              font-weight: 500;
            }
          }

          .range_radius {
            appearance: slider-vertical;
            width: 8px;
            height: 100px;
            padding: 0 5px;
          }
        }

        svg {
          transition: all 0.2s linear;

          &.rotated {
            transform: rotate(180deg);
            transition: all 0.2s linear;
          }
        }
      }
    }

    .near_station {
      cursor: pointer;
      position: absolute;
      bottom: 200px;
      right: 10px;
      z-index: 401;
      backdrop-filter: blur(5px);
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(255, 255, 255, 0.7);
      box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.28);
      width: 50px;
      height: 50px;
      border-radius: 5px;
    }

    .nfc {
      position: absolute;
      left: 10px;
      bottom: 74px;
      width: 50px;
      height: 50px;
      z-index: 401;
      background: rgba(255, 255, 255, 0.7);
      border-radius: 5px;
      backdrop-filter: blur(5px);
      box-shadow: 0 1px 6px 0 rgb(32 33 36 / 28%);

      &.waiting {
        svg {
          animation: fill-pulse 2s infinite;
        }
      }

      &.disable {
        box-shadow: none;

        svg {
          fill: gray;
          opacity: 0.8;
        }
      }

      @keyframes fill-pulse {
        0% {
          fill: #000000;
        }

        70% {
          fill: rgba(98, 163, 33, 1);
        }

        100% {
          fill: #000000;
        }
      }
    }

    .location_modal {
      position: fixed;
      background: rgba(255, 255, 255);
      // top: 115px;
      top: 45px;
      left: calc(50% - 140px);
      width: 300px;
      min-height: 80px;
      z-index: 401;
      box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.28);
      display: flex;
      align-items: center;
      justify-content: center;
      // border-radius: 5px;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      border-bottom-left-radius: 5px;
      padding: 5px;

      .row11 {
        .charge_status {
          width: 100%;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 5px;
          border-left: 1px solid rgba(0, 0, 0, 0.05);
          border-right: 1px solid rgba(0, 0, 0, 0.05);
          border-bottom: 1px solid rgba(0, 0, 0, 0.05);
          background-color: #62a321;
          color: #fff;

          span {
            line-height: 1;
          }
        }
      }

      &.vertical_flex {
        flex-direction: column;
      }

      .modal_header {
        position: absolute;
        cursor: pointer;
        bottom: -39px;
        right: 0px;
        display: flex;
        height: 40px;
        width: 60px;
        font-weight: 700;
        background: rgba(255, 255, 255);
        justify-content: center;
        align-items: center;
        line-height: 1;
        font-size: 20px;
        color: red;
        border-bottom-right-radius: 5px;
        border-bottom-left-radius: 5px;
      }

      .default_charge {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        font-size: 0.8rem;
        font-weight: 400;
        // color: #808080;
        color: #000;

        .location_info {
          display: flex;
          flex-direction: column;
          width: 100%;

          .row1 {
            display: flex;

            .left {
              overflow: hidden;
              display: flex;
              align-items: center;
              padding: 5px;
              border-left: 1px solid rgba(0, 0, 0, 0.05);
              border-top: 1px solid rgba(0, 0, 0, 0.05);
              border-top-left-radius: 5px;
              width: 80%;

              span {
                line-height: 1;
              }
            }

            .right {
              overflow: hidden;
              display: flex;
              align-items: center;
              justify-content: center;
              border-top: 1px solid rgba(0, 0, 0, 0.05);
              border-right: 1px solid rgba(0, 0, 0, 0.05);
              border-top-right-radius: 5px;
              padding: 5px;
              min-width: 20%;

              hr {
                height: 100%;
                width: 1px;
                background: rgba(0, 0, 0, 0.05);
                border: none;
              }

              .heart {
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.2s linear;
                cursor: pointer;
                padding: 0 10px;

                &.favorite {
                  svg {
                    path {
                      fill: red;
                    }
                  }
                }

                svg {
                  transition: all 0.2s linear;
                  width: 30px;
                  height: 30px;
                }
              }

              .share {
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.2s linear;
                cursor: pointer;
                padding: 0 10px;

                svg {
                  width: 30px;
                  height: 30px;
                }
              }
            }
          }

          .row2 {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-left: 1px solid rgba(0, 0, 0, 0.05);
            border-right: 1px solid rgba(0, 0, 0, 0.05);
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);

            .tariff {
              width: 60%;
              padding-left: 5px;
            }

            hr {
              width: 1px;
              height: 100%;
              background: rgba(0, 0, 0, 0.05);
              border: none;
            }

            .worktime {
              padding-right: 5px;
              width: calc(40% - 1px);
              display: flex;
              align-items: center;
              justify-content: flex-end;

              svg {
                margin-right: 5px;
              }
            }
          }
        }

        .stations {
          display: flex;
          flex-direction: column;
          position: relative;

          .station {
            border: 1px solid rgba(0, 0, 0, 0.05);
            display: flex;
            width: 100%;
            // height: 70px;
            position: relative;
            margin-bottom: 3px;
            &:first-child {
              margin-top: 3px;
            }

            .station_info_inner_left {
              display: flex;
              width: 75%;
              position: relative;

              .id {
                width: 20%;
                font-size: 1.2rem;
                font-weight: 600;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 5px;

                &.green {
                  color: #61a321;
                }

                &.blue {
                  color: #38529e;
                }

                &.gray {
                  color: #9d9e9e;
                }

                &.red {
                  color: #e31e24;
                }
              }

              .properties {
                position: relative;
                width: 80%;
                display: flex;
                flex-direction: column;
                font-size: 0.8rem;
                justify-content: flex-start;
                padding: 5px;

                span {
                  line-height: 1.1;

                  &.green {
                    color: #61a321;
                  }

                  &.blue {
                    color: #38529e;
                  }

                  &.gray {
                    color: #9d9e9e;
                  }

                  &.red {
                    color: #e31e24;
                  }
                }
              }
            }

            .station_info_inner_rfid_status {
              display: flex;
              align-items: center;
              justify-content: center;
              transition: all 0.2s linear;
              position: absolute;
              left: 64%;
              z-index: 0;
              top: 0;
              bottom: 0;
              margin: auto 0;
            }

            .station_info_inner_right {
              width: 25%;
              display: flex;
              align-items: center;
              justify-content: center;
              transition: all 0.2s linear;
              cursor: pointer;
              position: relative;

              &.disabled {
                .start_charge_btn {
                  display: none;
                }
              }

              .start_charge_btn {
                text-align: center;
                font-weight: 600;
                font-size: 12px;
                color: green;
                line-height: 1;
              }

              .status_active_charge {
                display: flex;
                flex-direction: column;
                width: 100%;
                height: 100%;
                justify-content: center;
                align-items: center;
                color: blue;

                svg {
                  position: relative;
                  top: -8px;
                }

                span {
                  position: relative;
                  right: auto;
                  left: auto;
                  bottom: 2px;
                  color: blue;
                }
              }

              svg path {
                transition: all 0.2s linear;
              }

              &:hover:not(.disabled) {
                transition: all 0.2s linear;
                background: rgba(97, 163, 33, 0.9);

                svg path {
                  fill: #fff;
                  transition: all 0.2s linear;
                }
              }
            }
          }
        }

        .location_modal_bottom {
          padding: 5px;
          border-left: 1px solid rgba(0, 0, 0, 0.05);
          border-right: 1px solid rgba(0, 0, 0, 0.05);
          border-bottom: 1px solid rgba(0, 0, 0, 0.05);
          border-top: 1px solid rgba(0, 0, 0, 0.05);
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .select_navigator {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: row;

            .item {
              cursor: pointer;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: 10px;

              &:last-child {
                margin-right: 0;
              }

              svg {
                  width: 30px;
                  height: 30px;
                path {
                  fill: #61a321;
                }
              }
            }
          }
        }
      }

      .confirmation_charge {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        font-size: 0.8rem;
        font-weight: 400;
        // color: #808080;
        color: #000;

        .location_info {
          display: flex;
          width: 100%;
          overflow: hidden;
          justify-content: space-between;

          span {
            line-height: 1;
          }

          span:nth-child(1) {
            border: 1px solid rgba(0, 0, 0, 0.05);
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            padding: 5px;
            width: 100%;
          }
        }

        .confirm_block {
          display: flex;
          flex-direction: column;
          margin-top: 5px;
          grid-gap: 5px;

          .prepared_sockets {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            height: 40px;
            padding: 5px;
            border: 1px solid rgba(0, 0, 0, 0.05);

            &.disabled {
              background: rgba(0, 0, 0, 0.05);
            }

            label {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin: 0;
              width: 100%;
            }

            .prepared_sockets-radio {
              display: flex;
              align-items: center;
              justify-content: center;
              input {
                height: 20px;
                width: 20px;
              }
            }
            .prepared_sockets-plug-type-name {
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 15px;
              font-weight: 600;
            }

            .prepared_sockets-plug-percent {
              margin-left: 5px;
              font-size: 15px;
              font-weight: 600;
            }

            .prepared_sockets-plug-power {
              margin-left: 5px;
              font-size: 15px;
              font-weight: 600;
            }

            .prepared_sockets-img {
              display: flex;
              align-items: center;
              justify-content: center;
              overflow: hidden;
              height: 100%;
              width: 40px;

              img {
                height: 100%;
              }
            }
          }

          .prepared_sockets-btn {
              display: flex;

              button {
                border: 1px solid #62a321;
                padding: 5px;
                width: 100%;
                display: flex;
                font-weight: 600;
                font-size: 18px;
                cursor: pointer;
                justify-content: center;
                align-items: center;
                background: #62a321;
                color: #fff;
                outline: none;
                transition: all 0.2s linear;

                &.disabled {
                  user-select: none;
                  pointer-events: none;
                  background: gray;
                  border-color: gray;
                  cursor: default;
                }

                &:hover {
                  background: rgba(98, 163, 33, 0.1);
                  transition: all 0.2s linear;
                  color: #62a321;
                }
              }
            }

          span {
            border: 1px solid rgba(0, 0, 0, 0.05);
            width: 100%;
            padding: 5px;
            font-weight: 400;
            text-align: center;
          }
        }
      }

      .activated_charge {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        font-size: 0.8rem;
        font-weight: 400;
        // color: #808080;
        color: #000;

        .location_info {
          display: flex;
          flex-direction: column;
          width: 100%;
          overflow: hidden;
          padding: 5px;
          border: 1px solid rgba(0, 0, 0, 0.05);
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
          line-height: 1;
        }

        .activated_charge_inner {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          border: 1px solid rgba(0, 0, 0, 0.05);
          padding: 5px;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          margin-top: 5px;
          position: relative;

          .timer {
            font-size: 1rem;
            font-weight: 500;
            // color: #808080;
            color: #000;
            margin-top: 15px;
            position: absolute;
            top: 11px;
          }

          img {
            width: 64px;
          }

          p {
            font-size: 1.2rem;
            font-weight: 500;
            // color: #808080;
            color: #000;
            margin-top: 5px;
            margin-bottom: 0;
          }
        }
      }

      .started_charge {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        font-size: 0.8rem;
        font-weight: 400;
        // color: #808080;
        color: #000;

        .reconnect_spinner {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 200px;
        }

        .location_info {
          display: flex;
          flex-direction: column;
          width: 100%;

          .row1 {
            display: flex;

            .left {
              width: 100%;
              overflow: hidden;
              display: flex;
              align-items: center;
              padding: 5px;
              border-left: 1px solid rgba(0, 0, 0, 0.05);
              border-top: 1px solid rgba(0, 0, 0, 0.05);
              border-bottom: 1px solid rgba(0, 0, 0, 0.05);
              border-top-left-radius: 5px;

              span {
                line-height: 1;
              }
            }

            .right {
              overflow: hidden;
              display: flex;
              align-items: center;
              justify-content: center;
              border: 1px solid rgba(0, 0, 0, 0.05);
              border-top-right-radius: 5px;

              hr {
                height: 100%;
                width: 1px;
                background: rgba(0, 0, 0, 0.05);
                border: none;
              }

              .gps {
                display: flex;
                justify-content: center;
                align-items: center;
                transition: all 0.2s linear;
                height: 100%;
                cursor: pointer;
                padding: 0 10px;
                display: none !important;

                svg {
                  transition: all 0.2s linear;
                  width: 30px;
                  height: 30px;
                }

                &:hover {
                  background: rgba(0, 0, 0, 0.05);
                  transition: all 0.2s linear;

                  svg {
                    path {
                      fill: #fff;
                      transition: all 0.2s linear;
                    }
                  }
                }
              }

              .heart {
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.2s linear;
                cursor: pointer;
                padding: 0 10px;

                &.favorite {
                  svg {
                    path {
                      fill: red;
                    }
                  }
                }

                svg {
                  transition: all 0.2s linear;
                  width: 30px;
                  height: 30px;
                }

                &:hover {
                  background: rgba(0, 0, 0, 0.2);
                  transition: all 0.2s linear;

                  svg {
                    path {
                      fill: #fff;
                      transition: all 0.2s linear;
                    }
                  }
                }
              }

              .share {
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.2s linear;
                cursor: pointer;
                padding: 0 10px;

                svg {
                  width: 30px;
                  height: 30px;
                }
              }
            }
          }

          .row2 {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
            border-left: 1px solid rgba(0, 0, 0, 0.05);
            border-right: 1px solid rgba(0, 0, 0, 0.05);

            .distance {
              width: 100%;
              padding-left: 5px;
            }

            hr {
              width: 1px;
              height: 100%;
              background: rgba(0, 0, 0, 0.05);
              border: none;
            }

            .worktime {
              padding-right: 5px;
              width: calc(50% - 1px);
              display: none;
              align-items: center;
              justify-content: flex-end;

              svg {
                margin-right: 5px;
              }
            }
          }
        }

        .started_charge_inner {
          display: flex;
          flex-direction: column;
          width: 100%;
          height: 100%;
          font-size: 0.8rem;
          font-weight: 400;
          // color: #808080;
          color: #000;

          .data {
            margin-top: 5px;

            .flex_row {
              display: flex;
              border: 1px solid rgba(0, 0, 0, 0.05);
              border-bottom: none;

              &:last-child {
                border-bottom: 1px solid rgba(0, 0, 0, 0.05);
              }

              .flex_column {
                padding: 3px;
                font-size: 0.7rem;

                &:first-child {
                  width: calc(55% + 1px);
                  border-right: 1px solid rgba(0, 0, 0, 0.05);
                }

                &:last-child {
                  color: #62a321;
                  width: calc(45% - 1px);
                  text-align: center;
                }
              }
            }
          }

          .finish_charge {
            margin-top: 5px;
            border: 1px solid rgba(0, 0, 0, 0.05);
            padding: 5px;
            display: flex;
            cursor: pointer;
            justify-content: center;
            align-items: center;
            background: transparent;
            font-weight: 700;
            text-transform: uppercase;
            background-color: red;
            color: #fff;
            outline: none;
            transition: all 0.2s linear;

            &.disabled {
              cursor: default;
              user-select: none;
              pointer-events: none;
              background-color: gray;
            }

            &:hover {
              background: rgba(0, 0, 0, 0.05);
              transition: all 0.2s linear;
            }
          }
        }

        .tariff {
          margin-top: 5px;
          border: 1px solid rgba(0, 0, 0, 0.05);
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          display: flex;
          justify-content: center;
          text-align: center;
          align-items: center;
        }
      }

      .finished_charge {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        font-size: 0.8rem;
        font-weight: 400;
        // color: #808080;
        color: #000;

        .finished_charge_inner {
          display: flex;
          flex-direction: column;
          width: 100%;
          height: 100%;
          font-size: 0.8rem;
          font-weight: 400;
          // color: #808080;
          color: #000;

          .charge_location {
            border: 1px solid rgba(0, 0, 0, 0.05);
            padding: 5px;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;

            strong {
              color: #62a321;
            }
          }

          .data {
            margin-top: 5px;

            .flex_row {
              display: flex;
              border: 1px solid rgba(0, 0, 0, 0.05);
              border-bottom: none;

              &:last-child {
                border-bottom: 1px solid rgba(0, 0, 0, 0.05);
              }

              .flex_column {
                padding: 5px;
                font-size: 0.8rem;

                &:first-child {
                  width: calc(70% + 1px);
                  border-right: 1px solid rgba(0, 0, 0, 0.05);
                }

                &:last-child {
                  color: #62a321;
                  width: calc(30% - 1px);
                  text-align: center;
                }
              }
            }
          }

          .finish_charge {
            margin-top: 5px;
            border: 1px solid rgba(0, 0, 0, 0.05);
            padding: 5px;
            display: flex;
            cursor: pointer;
            justify-content: center;
            align-items: center;
            background: transparent;
            font-weight: 700;
            text-transform: uppercase;
            background-color: red;
            color: #fff;
            outline: none;
            transition: all 0.2s linear;

            &.disabled {
              cursor: default;
              user-select: none;
              pointer-events: none;
              background-color: gray;
            }

            &:hover {
              background: rgba(0, 0, 0, 0.05);
              transition: all 0.2s linear;
            }
          }
        }

        .tariff {
          margin-top: 5px;
          border: 1px solid rgba(0, 0, 0, 0.05);
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          text-align: center;
          line-height: 1.2;
        }
      }
    }
  }
}

@media screen and (max-width: 991px) {
  .map {
    .map_inner {
      .pwa_btn {
        bottom: 450px;
      }

      .location_modal {
        .default_charge {
          font-size: 0.9rem;

          .stations {
            .station {
              .station_info_inner_left {
                .id {
                  font-size: 1.5rem;
                }
              }

              .station_info_inner_right {
                .start_charge_btn {
                  font-size: 14px;
                }
              }
            }
          }
        }

        .confirmation_charge {
          font-size: 1rem;

          .confirm_block {
            button {
              font-size: 1rem;
            }
          }
        }

        .activated_charge {
          font-size: 1rem;

          .activated_charge_inner {
            .timer {
              font-size: 1.1rem;
            }

            p {
              font-size: 1.3rem;
            }
          }
        }

        .started_charge {
          font-size: 1rem;

          .location_info {
            .row1 {
              .right {
                min-width: 100px;
              }
            }
          }

          .started_charge_inner {
            font-size: 1rem;

            .data {
              .flex_row {
                .flex_column {
                  font-size: 1rem;
                }
              }
            }
          }
        }

        .finished_charge {
          font-size: 1rem;

          .finished_charge_inner {
            font-size: 1rem;

            .data {
              .flex_row {
                .flex_column {
                  font-size: 1rem;
                }
              }
            }
          }
        }

        .stations_view {
          .location_info {
            .row1 {
              .right {
                .heart {
                  &:hover {
                    background: transparent;

                    svg {
                      path {
                        fill: #808080;
                      }
                    }
                  }

                  &.favorite {
                    &:hover {
                      svg {
                        path {
                          fill: red;
                        }
                      }
                    }
                  }
                }

                .gps {
                  &:hover {
                    background: transparent;

                    svg {
                      path {
                        fill: #808080;
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .station_info_inner_right:not(.disabled) {
          &:hover {
            background: transparent !important;
          }

          svg path {
            fill: #808080 !important;
          }
        }
      }

      .near_station {
        position: relative;
        width: 50px;
        height: 50px;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.3) !important;
        border-radius: 5px;
      }

      .coverage_area {
        width: 50px;
        top: auto;
        left: auto;
        bottom: 190px;
        right: 10px;
        display: flex;
        flex-direction: column-reverse;
        box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.3) !important;
        border-radius: 5px;

        .circle_radius {
          width: 50px;
          margin-top: 0;
          border-radius: 5px 5px 0 0;
          flex-direction: column-reverse;
          border-top: none;
          border-bottom: 1px solid #ccc;

          svg {
            transform: rotate(180deg);

            &.rotated {
              transform: rotate(0);
            }
          }
        }

        .icon {
          width: 50px;
          height: 30px;
          border-radius: 0 0 5px 5px;
        }
      }

      .info_btn {
        position: relative;
        bottom: 0;
        top: 0;
        left: 0;
        right: 0;
      }

      .reload_btn {
        position: relative;
        bottom: 0;
        top: 0;
        left: 0;
        right: 0;
      }

      .dc_btn {
        position: relative;
        bottom: 0;
        top: 0;
        left: 0;
        right: 0;
      }
    }
  }
  .map {
    .map_inner {
      .location_modal {
        width: calc(100% - 10px);
        left: 5px;
      }
    }
  }
}

@media screen and (max-width: 575px) {
  .map {
    .map_inner {
      .nfc {
        right: 10px;
        left: auto;
        bottom: 380px;
      }
    }
  }
}
</style>
